var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// dist/index.js
var dist_exports = {};
__export(dist_exports, {
  ArrowStyles: () => ArrowStyles,
  CompositeMode: () => CompositeMode,
  DEFAULT_ARROWS: () => DEFAULT_ARROWS,
  Draw90DegreePolygonMode: () => Draw90DegreePolygonMode,
  DrawCircleByDiameterMode: () => DrawCircleByDiameterMode,
  DrawCircleFromCenterMode: () => DrawCircleFromCenterMode,
  DrawEllipseByBoundingBoxMode: () => DrawEllipseByBoundingBoxMode,
  DrawEllipseUsingThreePointsMode: () => DrawEllipseUsingThreePointsMode,
  DrawLineStringMode: () => DrawLineStringMode,
  DrawPointMode: () => DrawPointMode,
  DrawPolygonByDraggingMode: () => DrawPolygonByDraggingMode,
  DrawPolygonMode: () => DrawPolygonMode,
  DrawRectangleFromCenterMode: () => DrawRectangleFromCenterMode,
  DrawRectangleMode: () => DrawRectangleMode,
  DrawRectangleUsingThreePointsMode: () => DrawRectangleUsingThreePointsMode,
  DrawSquareFromCenterMode: () => DrawSquareFromCenterMode,
  DrawSquareMode: () => DrawSquareMode,
  DuplicateMode: () => DuplicateMode,
  EditableGeoJsonLayer: () => EditableGeoJsonLayer,
  EditableH3ClusterLayer: () => EditableH3ClusterLayer,
  ElevatedEditHandleLayer: () => ElevatedEditHandleLayer,
  ElevationMode: () => ElevationMode,
  ExtendLineStringMode: () => ExtendLineStringMode,
  ExtrudeMode: () => ExtrudeMode,
  Feature: () => Feature,
  GeoJsonEditMode: () => GeoJsonEditMode,
  ImmutableFeatureCollection: () => ImmutableFeatureCollection,
  JunctionScatterplotLayer: () => JunctionScatterplotLayer,
  JunctionsLayer: () => JunctionsLayer,
  LayerMouseEvent: () => LayerMouseEvent,
  MAX_ARROWS: () => MAX_ARROWS,
  MeasureAngleMode: () => MeasureAngleMode,
  MeasureAreaMode: () => MeasureAreaMode,
  MeasureDistanceMode: () => MeasureDistanceMode,
  ModifyMode: () => ModifyMode,
  NebulaCore: () => NebulaCore,
  NebulaLayer: () => NebulaLayer,
  PROJECTED_PIXEL_SIZE_MULTIPLIER: () => PROJECTED_PIXEL_SIZE_MULTIPLIER,
  ResizeCircleMode: () => ResizeCircleMode,
  RotateMode: () => RotateMode,
  SELECTION_TYPE: () => SELECTION_TYPE,
  ScaleMode: () => ScaleMode,
  SegmentsLayer: () => SegmentsLayer,
  SelectionLayer: () => SelectionLayer,
  SnappableMode: () => SnappableMode,
  SplitPolygonMode: () => SplitPolygonMode,
  TextsLayer: () => TextsLayer,
  TransformMode: () => TransformMode,
  TranslateMode: () => TranslateMode,
  ViewMode: () => ViewMode,
  _memoize: () => memoize,
  getEditHandlesForGeometry: () => getEditHandlesForGeometry,
  getPickedEditHandle: () => getPickedEditHandle,
  toDeckColor: () => toDeckColor,
  utils: () => utils_exports
});
module.exports = __toCommonJS(dist_exports);

// dist/lib/style.js
var ArrowStyles = {
  NONE: 0,
  FORWARD: 1,
  BACKWARD: 2,
  BOTH: 3
};
var DEFAULT_ARROWS = 1;
var MAX_ARROWS = 3;
var DEFAULT_STYLE = {
  arrowColor: [0, 0, 0, 1],
  arrowCount: DEFAULT_ARROWS,
  arrowStyle: ArrowStyles.NONE,
  fillColor: [0, 0, 0, 1],
  lineColor: [0, 0, 0, 1],
  lineWidthMeters: 5,
  outlineRadiusMeters: 0,
  opacity: 1,
  zLevel: 0
};

// dist/lib/deck-renderer/deck-drawer.js
var import_layers = require("@deck.gl/layers");
var import_helpers = require("@turf/helpers");
var import_bbox = __toESM(require("@turf/bbox"), 1);
var import_bbox_polygon = __toESM(require("@turf/bbox-polygon"), 1);
var import_buffer = __toESM(require("@turf/buffer"), 1);
var import_difference = __toESM(require("@turf/difference"), 1);
var import_distance = __toESM(require("@turf/distance"), 1);
var POLYGON_LINE_COLOR = [0, 255, 0, 255];
var POLYGON_FILL_COLOR = [255, 255, 255, 90];
var POLYGON_LINE_WIDTH = 2;
var POLYGON_THRESHOLD = 0.01;
var EXPANSION_KM = 10;
var LAYER_ID_VIEW = "DeckDrawerView";
var LAYER_ID_PICK = "DeckDrawerPick";
var SELECTION_TYPE = {
  NONE: null,
  RECTANGLE: "rectangle",
  POLYGON: "polygon"
};
var DeckDrawer = class {
  nebula;
  usePolygon;
  validPolygon;
  landPoints;
  mousePoints;
  constructor(nebula) {
    this.nebula = nebula;
    this.usePolygon = false;
    this.validPolygon = true;
    this.landPoints = [];
    this.mousePoints = [];
  }
  _getLayerIds() {
    return this.nebula.deckgl.props.layers.filter((l) => l && l.props && l.props.nebulaLayer && l.props.nebulaLayer.enableSelection).map((l) => l.id);
  }
  _selectFromPickingInfos(pickingInfos) {
    const objects = pickingInfos.map(({ layer, index, object }) => object.original || layer.props.nebulaLayer.deckCache.originals[index]);
    this.nebula.props.onSelection(objects);
  }
  _getBoundingBox() {
    const { mousePoints } = this;
    const allX = mousePoints.map((mousePoint) => mousePoint[0]);
    const allY = mousePoints.map((mousePoint) => mousePoint[1]);
    const x = Math.min(...allX);
    const y = Math.min(...allY);
    const maxX = Math.max(...allX);
    const maxY = Math.max(...allY);
    return { x, y, width: maxX - x, height: maxY - y };
  }
  _selectRectangleObjects() {
    if (this.landPoints.length !== 2)
      return;
    const [x1, y1] = this.mousePoints[0];
    const [x2, y2] = this.mousePoints[1];
    const pickingInfos = this.nebula.deckgl.pickObjects({
      x: Math.min(x1, x2),
      y: Math.min(y1, y2),
      width: Math.abs(x2 - x1),
      height: Math.abs(y2 - y1),
      layerIds: this._getLayerIds()
    });
    this._selectFromPickingInfos(pickingInfos);
  }
  _selectPolygonObjects() {
    const pickingInfos = this.nebula.deckgl.pickObjects({
      ...this._getBoundingBox(),
      layerIds: [LAYER_ID_PICK, ...this._getLayerIds()]
    });
    this._selectFromPickingInfos(pickingInfos.filter((item) => item.layer.id !== LAYER_ID_PICK));
  }
  _getMousePosFromEvent(event) {
    const { offsetX, offsetY } = event;
    return [offsetX, offsetY];
  }
  // eslint-disable-next-line max-statements, complexity
  handleEvent(event, lngLat, selectionType) {
    if (event.type !== "mouseup")
      event.stopPropagation();
    this.usePolygon = selectionType === SELECTION_TYPE.POLYGON;
    let redraw = false;
    let deactivate = false;
    const { usePolygon, landPoints, mousePoints } = this;
    if (event.type === "mousedown") {
      if (usePolygon && landPoints.length) {
        if (this.landPoints.length < 3 || this.validPolygon) {
          landPoints.push(lngLat);
          mousePoints.push(this._getMousePosFromEvent(event));
        }
      } else {
        this.landPoints = [lngLat, lngLat];
        const m = this._getMousePosFromEvent(event);
        this.mousePoints = [m, m];
      }
      redraw = true;
    } else if (event.type === "mousemove" && landPoints.length) {
      landPoints[landPoints.length - 1] = lngLat;
      mousePoints[mousePoints.length - 1] = this._getMousePosFromEvent(event);
      redraw = true;
    } else if (event.type === "mouseup") {
      if (usePolygon) {
        if (landPoints.length > 4 && (0, import_distance.default)(landPoints[0], landPoints[landPoints.length - 1]) < POLYGON_THRESHOLD && this.validPolygon) {
          this._selectPolygonObjects();
          this.reset();
          redraw = true;
          deactivate = true;
        }
      } else {
        this._selectRectangleObjects();
        this.reset();
        redraw = true;
        deactivate = true;
      }
    }
    return { redraw, deactivate };
  }
  reset() {
    this.landPoints = [];
    this.mousePoints = [];
  }
  _makeStartPointHighlight(center) {
    const buffer = (0, import_buffer.default)((0, import_helpers.point)(center), POLYGON_THRESHOLD / 4);
    return (0, import_bbox_polygon.default)((0, import_bbox.default)(buffer)).geometry.coordinates;
  }
  render() {
    const data = [];
    const dataPick = [];
    if (!this.usePolygon && this.landPoints.length === 2) {
      const [[x1, y1], [x2, y2]] = this.mousePoints;
      const selPolygon = [
        [x1, y1],
        [x1, y2],
        [x2, y2],
        [x2, y1],
        [x1, y1]
      ].map((mousePos) => this.nebula.unprojectMousePosition(mousePos));
      data.push({
        polygon: selPolygon,
        lineColor: POLYGON_LINE_COLOR,
        fillColor: POLYGON_FILL_COLOR
      });
    } else if (this.usePolygon && this.landPoints.length) {
      data.push({
        polygon: this.landPoints,
        lineColor: POLYGON_LINE_COLOR,
        fillColor: POLYGON_FILL_COLOR
      });
      if (this.landPoints.length >= 3) {
        const landPointsPoly = (0, import_helpers.polygon)([[...this.landPoints, this.landPoints[0]]]);
        const bigBuffer = (0, import_buffer.default)((0, import_helpers.point)(this.landPoints[0]), EXPANSION_KM);
        let bigPolygon;
        try {
          bigPolygon = (0, import_difference.default)(bigBuffer, landPointsPoly);
          dataPick.push({
            polygon: bigPolygon.geometry.coordinates,
            fillColor: [0, 0, 0, 1]
          });
          this.validPolygon = true;
        } catch (e) {
          this.validPolygon = false;
        }
      }
    }
    if (this.landPoints.length) {
      data.push({
        polygon: this._makeStartPointHighlight(this.landPoints[0]),
        lineColor: [0, 0, 0, 0],
        fillColor: POLYGON_LINE_COLOR
      });
    }
    data.push({ polygon: [[0, 0]] });
    dataPick.push({ polygon: [[0, 0]] });
    return [
      new import_layers.PolygonLayer({
        id: LAYER_ID_VIEW,
        data,
        fp64: false,
        opacity: 1,
        pickable: false,
        lineWidthMinPixels: POLYGON_LINE_WIDTH,
        lineWidthMaxPixels: POLYGON_LINE_WIDTH,
        lineDashJustified: true,
        // TODO(v9) Add extension
        // getLineDashArray: (x) => POLYGON_DASHES,
        getLineColor: (obj) => obj.lineColor || [0, 0, 0, 255],
        getFillColor: (obj) => obj.fillColor || [0, 0, 0, 255],
        getPolygon: (o) => o.polygon
      }),
      new import_layers.PolygonLayer({
        id: LAYER_ID_PICK,
        data: dataPick,
        getLineColor: (obj) => obj.lineColor || [0, 0, 0, 255],
        getFillColor: (obj) => obj.fillColor || [0, 0, 0, 255],
        fp64: false,
        opacity: 1,
        stroked: false,
        pickable: true,
        getPolygon: (o) => o.polygon
      })
    ];
  }
};

// dist/lib/feature.js
var Feature = class {
  // geo json coordinates
  geoJson;
  style;
  original;
  metadata;
  constructor(geoJson, style, original = null, metadata = {}) {
    this.geoJson = geoJson;
    this.style = style;
    this.original = original;
    this.metadata = metadata;
  }
  getCoords() {
    return this.geoJson.geometry.coordinates;
  }
};

// dist/lib/layer-mouse-event.js
var LayerMouseEvent = class {
  canceled = false;
  // original item that this event is related to
  data;
  // internal nebula info about the object
  metadata;
  // the mouse [lng,lat] raycasted onto the ground
  groundPoint;
  // browser event
  nativeEvent;
  // reference to nebula
  nebula;
  constructor(nativeEvent, { data, groundPoint, nebula, metadata }) {
    this.nativeEvent = nativeEvent;
    this.data = data;
    this.groundPoint = groundPoint;
    this.nebula = nebula;
    this.metadata = metadata;
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation();
    this.canceled = true;
  }
};

// dist/lib/nebula-layer.js
var import_eventemitter3 = require("eventemitter3");
var import_uuid = require("uuid");
var NebulaLayer = class extends import_eventemitter3.EventEmitter {
  getData;
  toNebulaFeature;
  id;
  helperLayers;
  // flags
  usesMapEvents = false;
  enablePicking = false;
  enableSelection = false;
  //
  constructor({ getData, on, toNebulaFeature }) {
    super();
    this.id = (0, import_uuid.v4)();
    this.getData = getData;
    this.toNebulaFeature = toNebulaFeature;
    this.helperLayers = [];
    if (on) {
      Object.keys(on).forEach((key) => this.on(key, on[key]));
    }
  }
  render(config) {
    return null;
  }
};

// dist/utils/utils.js
var utils_exports = {};
__export(utils_exports, {
  distance2d: () => distance2d,
  generatePointsParallelToLinePoints: () => generatePointsParallelToLinePoints,
  insertBefore: () => insertBefore,
  mix: () => mix,
  nearestPointOnProjectedLine: () => nearestPointOnProjectedLine,
  recursivelyTraverseNestedArrays: () => recursivelyTraverseNestedArrays,
  toDeckColor: () => toDeckColor
});
var import_destination = __toESM(require("@turf/destination"), 1);
var import_bearing = __toESM(require("@turf/bearing"), 1);
var import_point_to_line_distance = __toESM(require("@turf/point-to-line-distance"), 1);
var import_helpers2 = require("@turf/helpers");
var import_viewport_mercator_project = require("viewport-mercator-project");
function toDeckColor(color, defaultColor = [255, 0, 0, 255]) {
  if (!Array.isArray(color)) {
    return defaultColor;
  }
  return [color[0] * 255, color[1] * 255, color[2] * 255, color[3] * 255];
}
function recursivelyTraverseNestedArrays(array, prefix, fn) {
  if (!Array.isArray(array[0])) {
    return true;
  }
  for (let i = 0; i < array.length; i++) {
    if (recursivelyTraverseNestedArrays(array[i], [...prefix, i], fn)) {
      fn(array, prefix);
      break;
    }
  }
  return false;
}
function generatePointsParallelToLinePoints(p1, p2, mapCoords2) {
  const lineString3 = {
    type: "LineString",
    coordinates: [p1, p2]
  };
  const pt = (0, import_helpers2.point)(mapCoords2);
  const ddistance = (0, import_point_to_line_distance.default)(pt, lineString3);
  const lineBearing = (0, import_bearing.default)(p1, p2);
  const isPointToLeftOfLine = (mapCoords2[0] - p1[0]) * (p2[1] - p1[1]) - (mapCoords2[1] - p1[1]) * (p2[0] - p1[0]);
  const orthogonalBearing = isPointToLeftOfLine < 0 ? lineBearing - 90 : lineBearing - 270;
  const p3 = (0, import_destination.default)(p2, ddistance, orthogonalBearing);
  const p4 = (0, import_destination.default)(p1, ddistance, orthogonalBearing);
  return [p3.geometry.coordinates, p4.geometry.coordinates];
}
function distance2d(x1, y1, x2, y2) {
  const dx = x1 - x2;
  const dy = y1 - y2;
  return Math.sqrt(dx * dx + dy * dy);
}
function mix(a, b, ratio) {
  return b * ratio + a * (1 - ratio);
}
function nearestPointOnProjectedLine(line, inPoint, viewport) {
  const wmViewport = new import_viewport_mercator_project.WebMercatorViewport(viewport);
  const coordinates = line.geometry.coordinates;
  const projectedCoords = coordinates.map(([x3, y3, z = 0]) => wmViewport.project([x3, y3, z]));
  const [x, y] = wmViewport.project(inPoint.geometry.coordinates);
  let minDistance = Infinity;
  let minPointInfo = {};
  projectedCoords.forEach(([x22, y22], index2) => {
    if (index2 === 0) {
      return;
    }
    const [x12, y12] = projectedCoords[index2 - 1];
    const A = y12 - y22;
    const B = x22 - x12;
    const C = x12 * y22 - x22 * y12;
    const div = A * A + B * B;
    const distance7 = Math.abs(A * x + B * y + C) / Math.sqrt(div);
    if (distance7 < minDistance) {
      minDistance = distance7;
      minPointInfo = {
        index: index2,
        x0: (B * (B * x - A * y) - A * C) / div,
        y0: (A * (-B * x + A * y) - B * C) / div
      };
    }
  });
  const { index, x0, y0 } = minPointInfo;
  const [x1, y1, z1 = 0] = projectedCoords[index - 1];
  const [x2, y2, z2 = 0] = projectedCoords[index];
  const lineLength = distance2d(x1, y1, x2, y2);
  const startToPointLength = distance2d(x1, y1, x0, y0);
  const ratio = startToPointLength / lineLength;
  const z0 = mix(z1, z2, ratio);
  return {
    type: "Feature",
    geometry: {
      type: "Point",
      coordinates: wmViewport.unproject([x0, y0, z0])
    },
    properties: {
      // TODO: calculate the distance in proper units
      dist: minDistance,
      index: index - 1
    }
  };
}
function insertBefore(base, insertBeforeText, toInsert) {
  const at = base.indexOf(insertBeforeText);
  if (at < 0) {
    return base;
  }
  return base.slice(0, at) + toInsert + base.slice(at);
}

// dist/lib/deck-renderer/deck-cache.js
var DeckCache = class {
  objects;
  originals;
  updateTrigger;
  _idToPosition;
  _getData;
  _convert;
  constructor(getData, convert) {
    this.objects = [];
    this.originals = [];
    this.updateTrigger = 0;
    this._idToPosition = /* @__PURE__ */ new Map();
    this._getData = getData;
    this._convert = convert;
  }
  updateAllDeckObjects() {
    if (!this._getData || !this._convert)
      return;
    this.originals.length = 0;
    this.objects.length = 0;
    this._idToPosition.clear();
    this._getData().forEach((d) => {
      this._idToPosition.set(d.id, this.objects.length);
      this.originals.push(d);
      this.objects.push(this._convert(d));
    });
    this.triggerUpdate();
  }
  updateDeckObjectsByIds(ids) {
    if (!this._getData || !this._convert)
      return;
    ids.forEach((id) => {
      const p = this._idToPosition.get(id);
      if (p !== void 0) {
        this.objects[p] = this._convert(this.originals[p]);
      }
    });
    this.triggerUpdate();
  }
  triggerUpdate() {
    this.updateTrigger++;
  }
  getDeckObjectById(id) {
    const p = this._idToPosition.get(id);
    return p !== void 0 ? this.objects[p] : null;
  }
  getOriginalById(id) {
    const p = this._idToPosition.get(id);
    return p !== void 0 ? this.originals[p] : null;
  }
};

// dist/editable-layers/junction-scatterplot-layer.js
var import_core = require("@deck.gl/core");
var import_layers2 = require("@deck.gl/layers");
var JunctionScatterplotLayer = class extends import_core.CompositeLayer {
  renderLayers() {
    const { id, getFillColor, getStrokeColor, getInnerRadius, updateTriggers } = this.props;
    return [
      // the full circles
      new import_layers2.ScatterplotLayer({
        ...this.props,
        id: `${id}-full`,
        data: this.props.data,
        getLineColor: getStrokeColor,
        updateTriggers: {
          ...updateTriggers,
          getStrokeColor: updateTriggers.getStrokeColor
        }
      }),
      // the inner part
      new import_layers2.ScatterplotLayer({
        ...this.props,
        id: `${id}-inner`,
        data: this.props.data,
        getFillColor,
        getRadius: getInnerRadius,
        pickable: false,
        updateTriggers: {
          ...updateTriggers,
          getFillColor: updateTriggers.getFillColor,
          getRadius: updateTriggers.getInnerRadius
        }
      })
    ];
  }
};
__publicField(JunctionScatterplotLayer, "layerName", "JunctionScatterplotLayer");
__publicField(JunctionScatterplotLayer, "defaultProps", {
  ...import_layers2.ScatterplotLayer.defaultProps,
  getFillColor: (d) => [0, 0, 0, 255],
  getStrokeColor: (d) => [255, 255, 255, 255],
  getInnerRadius: (d) => 1
});

// dist/lib/layers/junctions-layer.js
var JunctionsLayer = class extends NebulaLayer {
  deckCache;
  constructor(config) {
    super(config);
    this.deckCache = new DeckCache(config.getData, (data) => config.toNebulaFeature(data));
    this.enablePicking = true;
  }
  render({ nebula }) {
    const defaultColor = [0, 0, 0, 255];
    const { objects, updateTrigger } = this.deckCache;
    return new JunctionScatterplotLayer({
      id: `junctions-${this.id}`,
      data: objects,
      opacity: 1,
      pickable: true,
      getPosition: (nf) => nf.geoJson.geometry.coordinates,
      getFillColor: (nf) => toDeckColor(nf.style.fillColor) || defaultColor,
      getStrokeColor: (nf) => toDeckColor(nf.style.outlineColor) || toDeckColor(nf.style.fillColor) || defaultColor,
      getRadius: (nf) => nf.style.pointRadiusMeters + nf.style.outlineRadiusMeters || 1,
      getInnerRadius: (nf) => nf.style.pointRadiusMeters || 0.5,
      parameters: {
        depthCompare: "always"
      },
      updateTriggers: { all: updateTrigger },
      // @ts-expect-error TODO
      nebulaLayer: this
    });
  }
};

// dist/lib/layers/texts-layer.js
var import_layers3 = require("@deck.gl/layers");

// dist/lib/constants.js
var PROJECTED_PIXEL_SIZE_MULTIPLIER = 2 / 3;

// dist/lib/layers/texts-layer.js
var TextsLayer = class extends NebulaLayer {
  deckCache;
  constructor(config) {
    super(config);
    this.deckCache = new DeckCache(config.getData, (data) => config.toNebulaFeature(data));
  }
  render({ nebula }) {
    const defaultColor = [0, 0, 0, 255];
    const { objects, updateTrigger } = this.deckCache;
    const { zoom } = nebula.props.viewport;
    return new import_layers3.TextLayer({
      id: `texts-${this.id}`,
      data: objects,
      opacity: 1,
      fp64: false,
      pickable: false,
      getText: (nf) => nf.style.text,
      getPosition: (nf) => nf.geoJson.geometry.coordinates,
      getColor: (nf) => toDeckColor(nf.style.fillColor) || defaultColor,
      // TODO: layer should offer option to scale with zoom
      sizeScale: 1 / Math.pow(2, 20 - zoom),
      getSize: PROJECTED_PIXEL_SIZE_MULTIPLIER,
      updateTriggers: { all: updateTrigger },
      nebulaLayer: this
    });
  }
};

// dist/lib/layers/segments-layer.js
var import_layers4 = require("@deck.gl-community/layers");
var NEBULA_TO_DECK_DIRECTIONS = {
  [ArrowStyles.NONE]: { forward: false, backward: false },
  [ArrowStyles.FORWARD]: { forward: true, backward: false },
  [ArrowStyles.BACKWARD]: { forward: false, backward: true },
  [ArrowStyles.BOTH]: { forward: true, backward: true }
};
var SegmentsLayer = class extends NebulaLayer {
  deckCache;
  noBlend;
  highlightColor;
  arrowSize;
  jointRounded;
  capRounded;
  dashed;
  markerLayerProps;
  constructor(config) {
    super(config);
    this.deckCache = new DeckCache(config.getData, (data) => config.toNebulaFeature(data));
    this.enableSelection = true;
    this.enablePicking = config.enablePicking ?? true;
    this.noBlend = config.noBlend ?? false;
    this.jointRounded = config.jointRounded ?? true;
    this.capRounded = config.capRounded ?? true;
    this.dashed = config.dashed ?? false;
    this.markerLayerProps = config.markerLayerProps ?? null;
    this.highlightColor = [1, 1, 1, 1];
    this.arrowSize = 1;
  }
  getMouseOverSegment() {
    return null;
  }
  _calcMarkerPercentages(nf) {
    const { arrowPercentages } = nf.style;
    if (arrowPercentages) {
      return arrowPercentages;
    }
    const arrowStyle = nf.style.arrowStyle || DEFAULT_STYLE.arrowStyle;
    if (arrowStyle === ArrowStyles.NONE)
      return [];
    const arrowCount = Math.min(nf.style.arrowCount || DEFAULT_STYLE.arrowCount, MAX_ARROWS);
    return [[0.5], [0.33, 0.66], [0.25, 0.5, 0.75]][arrowCount - 1];
  }
  _getHighlightedObjectIndex({ nebula }) {
    const { deckglMouseOverInfo } = nebula;
    if (deckglMouseOverInfo) {
      const { originalLayer, index } = deckglMouseOverInfo;
      if (originalLayer === this) {
        return index;
      }
    }
    return -1;
  }
  render({ nebula }) {
    const defaultColor = [0, 0, 0, 255];
    const { objects, updateTrigger } = this.deckCache;
    return new import_layers4.PathMarkerLayer({
      id: `segments-${this.id}`,
      data: objects,
      opacity: 1,
      fp64: false,
      jointRounded: this.jointRounded,
      capRounded: this.capRounded,
      pickable: true,
      sizeScale: this.arrowSize || 6,
      parameters: {
        depthCompare: "always",
        blendColorOperation: this.noBlend ? void 0 : "max"
      },
      getPath: (nf) => nf.geoJson.geometry.coordinates,
      getColor: (nf) => toDeckColor(nf.style.lineColor, defaultColor),
      getWidth: (nf) => nf.style.lineWidthMeters || 1,
      getZLevel: (nf) => nf.style.zLevel * 255,
      getDirection: (nf) => NEBULA_TO_DECK_DIRECTIONS[nf.style.arrowStyle],
      getMarkerColor: (nf) => toDeckColor(nf.style.arrowColor, defaultColor),
      // eslint-disable-next-line @typescript-eslint/unbound-method
      getMarkerPercentages: this._calcMarkerPercentages,
      updateTriggers: { all: updateTrigger },
      highlightedObjectIndex: this._getHighlightedObjectIndex({ nebula }),
      highlightColor: toDeckColor(this.highlightColor),
      dashJustified: this.dashed,
      getDashArray: this.dashed ? (nf) => nf.style.dashArray : void 0,
      markerLayerProps: this.markerLayerProps || import_layers4.PathMarkerLayer.defaultProps.markerLayerProps,
      nebulaLayer: this
    });
  }
};

// dist/lib/nebula-core.js
var import_eventemitter32 = require("eventemitter3");
var import_core2 = require("@deck.gl/core");
var LOGGER_PREFIX = "Nebula: ";
var NebulaCore = class {
  init(props) {
    this.props = props;
    this.wmViewport = new import_core2.WebMercatorViewport(this.props.viewport);
    ["click", "mousemove", "mouseup", "mousedown"].forEach((name) => document.addEventListener(name, this._onMouseEvent, true));
  }
  detach() {
    ["click", "mousemove", "mouseup", "mousedown"].forEach((name) => document.removeEventListener(name, this._onMouseEvent, true));
  }
  updateProps(newProps) {
    this.props = newProps;
    const { viewport } = this.props;
    this.wmViewport = new import_core2.WebMercatorViewport(viewport);
  }
  props = null;
  deckgl = null;
  mainContainer = null;
  deckglMouseOverInfo = null;
  _deckDrawer = null;
  _mouseWasDown = null;
  wmViewport = null;
  queryObjectEvents = new import_eventemitter32.EventEmitter();
  forceUpdate = null;
  inited = null;
  log(message) {
    const { logger } = this.props;
    if (logger && logger.info) {
      logger.info(LOGGER_PREFIX + message);
    }
  }
  updateAllDeckObjects() {
    this.getAllLayers().forEach((layer) => {
      if (layer && layer.deckCache) {
        layer.deckCache.updateAllDeckObjects();
      }
    });
    this.forceUpdate();
  }
  updateDeckObjectsByIds(ids) {
    this.getAllLayers().forEach((layer) => {
      if (layer && layer.deckCache) {
        layer.deckCache.updateDeckObjectsByIds(ids);
      }
    });
    this.forceUpdate();
  }
  rerenderLayers() {
    this.updateAllDeckObjects();
  }
  _isNebulaEvent({ buttons, target, type }) {
    const { viewport } = this.props;
    if (this._mouseWasDown && type === "mouseup") {
      this._mouseWasDown = false;
      return true;
    }
    if (type === "mousemove" && buttons > 0) {
      return true;
    }
    if (!target.getBoundingClientRect) {
      return false;
    }
    const rect = target.getBoundingClientRect();
    return Math.round(rect.width) === Math.round(viewport.width) && Math.round(rect.height) === Math.round(viewport.height);
  }
  _onMouseEvent = (event) => {
    if (!this._isNebulaEvent(event)) {
      return;
    }
    if (event.type === "mousedown") {
      this._mouseWasDown = true;
    }
    const { top = 0, left = 0 } = this.mainContainer ? this.mainContainer.getBoundingClientRect() : {};
    const proxyEvent = new Proxy(event, {
      get: (original, propertyName) => {
        if (propertyName === "offsetX") {
          return original.pageX - left;
        }
        if (propertyName === "offsetY") {
          return original.pageY - top;
        }
        if (propertyName === "type") {
          return original.type.replace("pointer", "mouse");
        }
        const result = original[propertyName];
        if (typeof result === "function") {
          return result.bind(original);
        }
        return result;
      }
    });
    this._handleDeckGLEvent(proxyEvent);
  };
  getMouseGroundPosition(event) {
    return this.wmViewport.unproject([event.offsetX, event.offsetY]);
  }
  unprojectMousePosition(mousePosition) {
    return this.wmViewport.unproject(mousePosition);
  }
  // eslint-disable-next-line max-statements, complexity
  _handleDeckGLEvent(event) {
    const { deckgl, props: { onMapMouseEvent, selectionType, eventFilter } } = this;
    let sendMapEvent = true;
    let cursor = "auto";
    if (event && deckgl && selectionType) {
      if (!this._deckDrawer)
        this._deckDrawer = new DeckDrawer(this);
      const lngLat = this.getMouseGroundPosition(event);
      if (eventFilter && !eventFilter(lngLat, event))
        return;
      const drawerResult = this._deckDrawer.handleEvent(event, lngLat, selectionType);
      if (drawerResult.redraw)
        this.forceUpdate();
      return;
    }
    if (event && deckgl && (!event.buttons || event.type !== "mousemove")) {
      const layerIds = deckgl.props.layers.filter((l) => l && l.props && l.props.nebulaLayer && l.props.nebulaLayer.enablePicking).map((l) => l.id);
      const pickingInfo = deckgl.pickObject({
        x: event.offsetX,
        y: event.offsetY,
        radius: 5,
        layerIds
      });
      this.queryObjectEvents.emit("pick", { event, pickingInfo });
      if (pickingInfo) {
        sendMapEvent = false;
        const { index, lngLat } = pickingInfo;
        if (eventFilter && !eventFilter(lngLat, event))
          return;
        const { layer: deckLayer, object } = pickingInfo;
        if (deckLayer && deckLayer.props && deckLayer.props.nebulaLayer && deckLayer.props.nebulaLayer.eventHandler) {
          deckLayer.props.nebulaLayer.eventHandler(event, pickingInfo);
        }
        const original = object.original || deckLayer.props.nebulaLayer && deckLayer.props.nebulaLayer.deckCache && deckLayer.props.nebulaLayer.deckCache.originals[index];
        if (original) {
          this.deckglMouseOverInfo = { originalLayer: deckLayer.props.nebulaLayer, index };
          const nebulaMouseEvent = new LayerMouseEvent(event, {
            data: original,
            metadata: object.metadata,
            groundPoint: lngLat,
            nebula: this
          });
          deckLayer.props.nebulaLayer.emit(event.type, nebulaMouseEvent);
          this.forceUpdate();
        }
        cursor = "pointer";
      }
    }
    if (document.documentElement) {
      document.documentElement.style.cursor = cursor;
    }
    if (sendMapEvent) {
      this.deckglMouseOverInfo = null;
      const lngLat = this.getMouseGroundPosition(event);
      if (eventFilter && !eventFilter(lngLat, event))
        return;
      const nebulaMouseEvent = new LayerMouseEvent(event, {
        groundPoint: lngLat,
        nebula: this
      });
      this.getAllLayers().filter((layer) => layer && layer.usesMapEvents).forEach((layer) => layer.emit("mapMouseEvent", nebulaMouseEvent));
      this.getAllLayers().filter((layer) => layer && layer.props && layer.props.nebulaLayer && layer.props.nebulaLayer.mapMouseEvent).forEach((layer) => layer.props.nebulaLayer.mapMouseEvent(nebulaMouseEvent, layer));
      if (onMapMouseEvent) {
        onMapMouseEvent(event, lngLat);
      }
    }
  }
  getExtraDeckLayers() {
    const result = [];
    if (this._deckDrawer)
      result.push(...this._deckDrawer.render());
    return result;
  }
  renderDeckLayers() {
    return this.getAllLayers().map((layer) => layer instanceof NebulaLayer ? layer.render({ nebula: this }) : layer).filter(Boolean);
  }
  getAllLayers() {
    const result = [];
    this.props.layers.filter(Boolean).forEach((layer) => {
      result.push(layer);
      if (layer instanceof NebulaLayer) {
        result.push(...layer.helperLayers);
      }
    });
    return result.filter(Boolean);
  }
  getRenderedLayers() {
    return [...this.renderDeckLayers(), ...this.getExtraDeckLayers()];
  }
  updateAndGetRenderedLayers(layers, viewport, container) {
    if (this.inited) {
      this.updateProps({ layers, viewport });
      this.forceUpdate = () => container.forceUpdate();
    } else {
      this.inited = true;
      this.init({ layers, viewport });
      this.forceUpdate = () => container.forceUpdate();
      this.updateAllDeckObjects();
    }
    return this.getRenderedLayers();
  }
  setDeck(deckgl) {
    if (deckgl) {
      this.deckgl = deckgl;
    }
  }
  setMainContainer(mainContainer) {
    if (mainContainer) {
      this.mainContainer = mainContainer;
    }
  }
};

// dist/editable-layers/editable-geojson-layer.js
var import_layers6 = require("@deck.gl/layers");

// dist/edit-modes/geojson-edit-mode.js
var import_union = __toESM(require("@turf/union"), 1);
var import_difference2 = __toESM(require("@turf/difference"), 1);
var import_intersect = __toESM(require("@turf/intersect"), 1);
var import_rewind = __toESM(require("@turf/rewind"), 1);

// dist/edit-modes/utils.js
var import_destination2 = __toESM(require("@turf/destination"), 1);
var import_bearing2 = __toESM(require("@turf/bearing"), 1);
var import_point_to_line_distance2 = __toESM(require("@turf/point-to-line-distance"), 1);
var import_meta = require("@turf/meta");
var import_helpers3 = require("@turf/helpers");
var import_invariant = require("@turf/invariant");
var import_viewport_mercator_project2 = require("viewport-mercator-project");
function recursivelyTraverseNestedArrays2(array, prefix, fn) {
  if (!Array.isArray(array[0])) {
    return true;
  }
  for (let i = 0; i < array.length; i++) {
    if (recursivelyTraverseNestedArrays2(array[i], [...prefix, i], fn)) {
      fn(array, prefix);
      break;
    }
  }
  return false;
}
function generatePointsParallelToLinePoints2(p1, p2, coords) {
  const lineString3 = {
    type: "LineString",
    coordinates: [p1, p2]
  };
  const pt = (0, import_helpers3.point)(coords);
  const ddistance = (0, import_point_to_line_distance2.default)(pt, lineString3);
  const lineBearing = (0, import_bearing2.default)(p1, p2);
  const isPointToLeftOfLine = (coords[0] - p1[0]) * (p2[1] - p1[1]) - (coords[1] - p1[1]) * (p2[0] - p1[0]);
  const orthogonalBearing = isPointToLeftOfLine < 0 ? lineBearing - 90 : lineBearing - 270;
  const p3 = (0, import_destination2.default)(p2, ddistance, orthogonalBearing);
  const p4 = (0, import_destination2.default)(p1, ddistance, orthogonalBearing);
  return [p3.geometry.coordinates, p4.geometry.coordinates];
}
function distance2d2(x1, y1, x2, y2) {
  const dx = x1 - x2;
  const dy = y1 - y2;
  return Math.sqrt(dx * dx + dy * dy);
}
function mix2(a, b, ratio) {
  return b * ratio + a * (1 - ratio);
}
function nearestPointOnProjectedLine2(line, inPoint, viewport) {
  const wmViewport = new import_viewport_mercator_project2.WebMercatorViewport(viewport);
  const coordinates = line.geometry.coordinates;
  const projectedCoords = coordinates.map(([x3, y3, z = 0]) => wmViewport.project([x3, y3, z]));
  const [x, y] = wmViewport.project(inPoint.geometry.coordinates);
  let minDistance = Infinity;
  let minPointInfo = {};
  projectedCoords.forEach(([x22, y22], index2) => {
    if (index2 === 0) {
      return;
    }
    const [x12, y12] = projectedCoords[index2 - 1];
    const A = y12 - y22;
    const B = x22 - x12;
    const C = x12 * y22 - x22 * y12;
    const div = A * A + B * B;
    const distance7 = Math.abs(A * x + B * y + C) / Math.sqrt(div);
    if (distance7 < minDistance) {
      minDistance = distance7;
      minPointInfo = {
        index: index2,
        x0: (B * (B * x - A * y) - A * C) / div,
        y0: (A * (-B * x + A * y) - B * C) / div
      };
    }
  });
  const { index, x0, y0 } = minPointInfo;
  const [x1, y1, z1 = 0] = projectedCoords[index - 1];
  const [x2, y2, z2 = 0] = projectedCoords[index];
  const lineLength = distance2d2(x1, y1, x2, y2);
  const startToPointLength = distance2d2(x1, y1, x0, y0);
  const ratio = startToPointLength / lineLength;
  const z0 = mix2(z1, z2, ratio);
  return {
    type: "Feature",
    geometry: {
      type: "Point",
      coordinates: wmViewport.unproject([x0, y0, z0])
    },
    properties: {
      // TODO: calculate the distance in proper units
      dist: minDistance,
      index: index - 1
    }
  };
}
function nearestPointOnLine(lines, inPoint, viewport) {
  var _a, _b;
  let mercator;
  if (viewport) {
    mercator = new import_viewport_mercator_project2.WebMercatorViewport(viewport);
  }
  let closestPoint = (0, import_helpers3.point)([Infinity, Infinity], {
    dist: Infinity
  });
  if (!((_a = lines.geometry) == null ? void 0 : _a.coordinates.length) || ((_b = lines.geometry) == null ? void 0 : _b.coordinates.length) < 2) {
    return closestPoint;
  }
  (0, import_meta.flattenEach)(lines, (line) => {
    const coords = (0, import_invariant.getCoords)(line);
    const pointCoords = (0, import_invariant.getCoords)(inPoint);
    let minDist;
    let to;
    let from;
    let x;
    let y;
    let segmentIdx;
    let dist;
    if (coords.length > 1 && pointCoords.length) {
      let lineCoordinates;
      let pointCoordinate;
      if (mercator) {
        lineCoordinates = coords.map((lineCoordinate) => mercator.project(lineCoordinate));
        pointCoordinate = mercator.project(pointCoords);
      } else {
        lineCoordinates = coords;
        pointCoordinate = pointCoords;
      }
      for (let n = 1; n < lineCoordinates.length; n++) {
        if (lineCoordinates[n][0] !== lineCoordinates[n - 1][0]) {
          const slope = (lineCoordinates[n][1] - lineCoordinates[n - 1][1]) / (lineCoordinates[n][0] - lineCoordinates[n - 1][0]);
          const inverseSlope = lineCoordinates[n][1] - slope * lineCoordinates[n][0];
          dist = Math.abs(slope * pointCoordinate[0] + inverseSlope - pointCoordinate[1]) / Math.sqrt(slope * slope + 1);
        } else
          dist = Math.abs(pointCoordinate[0] - lineCoordinates[n][0]);
        const rl2 = Math.pow(lineCoordinates[n][1] - lineCoordinates[n - 1][1], 2) + Math.pow(lineCoordinates[n][0] - lineCoordinates[n - 1][0], 2);
        const ln2 = Math.pow(lineCoordinates[n][1] - pointCoordinate[1], 2) + Math.pow(lineCoordinates[n][0] - pointCoordinate[0], 2);
        const lnm12 = Math.pow(lineCoordinates[n - 1][1] - pointCoordinate[1], 2) + Math.pow(lineCoordinates[n - 1][0] - pointCoordinate[0], 2);
        const dist2 = Math.pow(dist, 2);
        const calcrl2 = ln2 - dist2 + lnm12 - dist2;
        if (calcrl2 > rl2) {
          dist = Math.sqrt(Math.min(ln2, lnm12));
        }
        if (minDist === null || minDist === void 0 || minDist > dist) {
          if (calcrl2 > rl2) {
            if (lnm12 < ln2) {
              to = 0;
              from = 1;
            } else {
              from = 0;
              to = 1;
            }
          } else {
            to = Math.sqrt(lnm12 - dist2) / Math.sqrt(rl2);
            from = Math.sqrt(ln2 - dist2) / Math.sqrt(rl2);
          }
          minDist = dist;
          segmentIdx = n;
        }
      }
      const dx = lineCoordinates[segmentIdx - 1][0] - lineCoordinates[segmentIdx][0];
      const dy = lineCoordinates[segmentIdx - 1][1] - lineCoordinates[segmentIdx][1];
      x = lineCoordinates[segmentIdx - 1][0] - dx * to;
      y = lineCoordinates[segmentIdx - 1][1] - dy * to;
    }
    let snapPoint = { x, y, idx: segmentIdx - 1, to, from };
    if (mercator) {
      const pixelToLatLong = mercator.unproject([snapPoint.x, snapPoint.y]);
      snapPoint = {
        x: pixelToLatLong[0],
        y: pixelToLatLong[1],
        idx: segmentIdx - 1,
        to,
        from
      };
    }
    closestPoint = (0, import_helpers3.point)([snapPoint.x, snapPoint.y], {
      dist: Math.abs(snapPoint.from - snapPoint.to),
      index: snapPoint.idx
    });
  });
  return closestPoint;
}
function getPickedEditHandle(picks) {
  const handles = getPickedEditHandles(picks);
  return handles.length ? handles[0] : null;
}
function getPickedSnapSourceEditHandle(picks) {
  const handles = getPickedEditHandles(picks);
  return handles.find((handle) => handle.properties.editHandleType === "snap-source");
}
function getNonGuidePicks(picks) {
  return picks && picks.filter((pick) => !pick.isGuide);
}
function getPickedExistingEditHandle(picks) {
  const handles = getPickedEditHandles(picks);
  return handles.find(({ properties }) => properties.featureIndex >= 0 && properties.editHandleType === "existing");
}
function getPickedIntermediateEditHandle(picks) {
  const handles = getPickedEditHandles(picks);
  return handles.find(({ properties }) => properties.featureIndex >= 0 && properties.editHandleType === "intermediate");
}
function getPickedEditHandles(picks) {
  const handles = picks && picks.filter((pick) => pick.isGuide && pick.object.properties.guideType === "editHandle").map((pick) => pick.object) || [];
  return handles;
}
function getEditHandlesForGeometry(geometry, featureIndex, editHandleType = "existing") {
  let handles = [];
  switch (geometry.type) {
    case "Point":
      handles = [
        {
          type: "Feature",
          properties: {
            guideType: "editHandle",
            editHandleType,
            positionIndexes: [],
            featureIndex
          },
          geometry: {
            type: "Point",
            coordinates: geometry.coordinates
          }
        }
      ];
      break;
    case "MultiPoint":
    case "LineString":
      handles = handles.concat(getEditHandlesForCoordinates(geometry.coordinates, [], featureIndex, editHandleType));
      break;
    case "Polygon":
    case "MultiLineString":
      for (let a = 0; a < geometry.coordinates.length; a++) {
        handles = handles.concat(getEditHandlesForCoordinates(geometry.coordinates[a], [a], featureIndex, editHandleType));
        if (geometry.type === "Polygon") {
          handles = handles.slice(0, -1);
        }
      }
      break;
    case "MultiPolygon":
      for (let a = 0; a < geometry.coordinates.length; a++) {
        for (let b = 0; b < geometry.coordinates[a].length; b++) {
          handles = handles.concat(getEditHandlesForCoordinates(geometry.coordinates[a][b], [a, b], featureIndex, editHandleType));
          handles = handles.slice(0, -1);
        }
      }
      break;
    default:
      throw Error(`Unhandled geometry type: ${geometry.type}`);
  }
  return handles;
}
function getEditHandlesForCoordinates(coordinates, positionIndexPrefix, featureIndex, editHandleType = "existing") {
  const editHandles = [];
  for (let i = 0; i < coordinates.length; i++) {
    const position = coordinates[i];
    editHandles.push({
      type: "Feature",
      properties: {
        guideType: "editHandle",
        positionIndexes: [...positionIndexPrefix, i],
        featureIndex,
        editHandleType
      },
      geometry: {
        type: "Point",
        coordinates: position
      }
    });
  }
  return editHandles;
}
function updateRectanglePosition(feature, editHandleIndex, coords) {
  const coordinates = feature.geometry.coordinates;
  if (!coordinates) {
    return null;
  }
  const points = coordinates[0].slice(0, 4);
  points[editHandleIndex % 4] = coords;
  const p0 = points[(editHandleIndex + 2) % 4];
  const p2 = points[editHandleIndex % 4];
  points[(editHandleIndex + 1) % 4] = [p2[0], p0[1]];
  points[(editHandleIndex + 3) % 4] = [p0[0], p2[1]];
  return [[...points, points[0]]];
}
function mapCoords(coords, callback) {
  if (typeof coords[0] === "number") {
    if (!isNaN(coords[0]) && isFinite(coords[0])) {
      return callback(coords);
    }
    return coords;
  }
  return coords.map((coord) => {
    return mapCoords(coord, callback);
  }).filter(Boolean);
}
function shouldCancelPan(event) {
  return event.picks.length && event.picks.find((p) => p.featureType === "points");
}

// dist/edit-modes/immutable-feature-collection.js
var ImmutableFeatureCollection = class {
  featureCollection;
  constructor(featureCollection4) {
    this.featureCollection = featureCollection4;
  }
  getObject() {
    return this.featureCollection;
  }
  /**
   * Replaces the position deeply nested withing the given feature's geometry.
   * Works with Point, MultiPoint, LineString, MultiLineString, Polygon, and MultiPolygon.
   *
   * @param featureIndex The index of the feature to update
   * @param positionIndexes An array containing the indexes of the position to replace
   * @param updatedPosition The updated position to place in the result (i.e. [lng, lat])
   *
   * @returns A new `ImmutableFeatureCollection` with the given position replaced. Does not modify this `ImmutableFeatureCollection`.
   */
  replacePosition(featureIndex, positionIndexes, updatedPosition) {
    const geometry = this.featureCollection.features[featureIndex].geometry;
    const isPolygonal = geometry.type === "Polygon" || geometry.type === "MultiPolygon";
    const updatedGeometry = {
      ...geometry,
      coordinates: immutablyReplacePosition(geometry.coordinates, positionIndexes, updatedPosition, isPolygonal)
    };
    return this.replaceGeometry(featureIndex, updatedGeometry);
  }
  /**
   * Removes a position deeply nested in a GeoJSON geometry coordinates array.
   * Works with MultiPoint, LineString, MultiLineString, Polygon, and MultiPolygon.
   *
   * @param featureIndex The index of the feature to update
   * @param positionIndexes An array containing the indexes of the postion to remove
   *
   * @returns A new `ImmutableFeatureCollection` with the given coordinate removed. Does not modify this `ImmutableFeatureCollection`.
   *
   */
  // eslint-disable-next-line complexity
  removePosition(featureIndex, positionIndexes) {
    const geometry = this.featureCollection.features[featureIndex].geometry;
    if (geometry.type === "Point") {
      throw Error("Can't remove a position from a Point or there'd be nothing left");
    }
    if (geometry.type === "MultiPoint" && // only 1 point left
    geometry.coordinates.length < 2) {
      throw Error("Can't remove the last point of a MultiPoint or there'd be nothing left");
    }
    if (geometry.type === "LineString" && // only 2 positions
    geometry.coordinates.length < 3) {
      throw Error("Can't remove position. LineString must have at least two positions");
    }
    if (geometry.type === "Polygon" && // outer ring is a triangle
    geometry.coordinates[0].length < 5 && Array.isArray(positionIndexes) && // trying to remove from outer ring
    positionIndexes[0] === 0) {
      throw Error("Can't remove position. Polygon's outer ring must have at least four positions");
    }
    if (geometry.type === "MultiLineString" && // only 1 LineString left
    geometry.coordinates.length === 1 && // only 2 positions
    geometry.coordinates[0].length < 3) {
      throw Error("Can't remove position. MultiLineString must have at least two positions");
    }
    if (geometry.type === "MultiPolygon" && // only 1 polygon left
    geometry.coordinates.length === 1 && // outer ring is a triangle
    geometry.coordinates[0][0].length < 5 && Array.isArray(positionIndexes) && // trying to remove from first polygon
    positionIndexes[0] === 0 && // trying to remove from outer ring
    positionIndexes[1] === 0) {
      throw Error("Can't remove position. MultiPolygon's outer ring must have at least four positions");
    }
    const isPolygonal = geometry.type === "Polygon" || geometry.type === "MultiPolygon";
    const updatedGeometry = {
      ...geometry,
      coordinates: immutablyRemovePosition(geometry.coordinates, positionIndexes, isPolygonal)
    };
    pruneGeometryIfNecessary(updatedGeometry);
    return this.replaceGeometry(featureIndex, updatedGeometry);
  }
  /**
   * Adds a position deeply nested in a GeoJSON geometry coordinates array.
   * Works with MultiPoint, LineString, MultiLineString, Polygon, and MultiPolygon.
   *
   * @param featureIndex The index of the feature to update
   * @param positionIndexes An array containing the indexes of the position that will proceed the new position
   * @param positionToAdd The new position to place in the result (i.e. [lng, lat])
   *
   * @returns A new `ImmutableFeatureCollection` with the given coordinate removed. Does not modify this `ImmutableFeatureCollection`.
   */
  addPosition(featureIndex, positionIndexes, positionToAdd) {
    const geometry = this.featureCollection.features[featureIndex].geometry;
    if (geometry.type === "Point") {
      throw new Error("Unable to add a position to a Point feature");
    }
    const isPolygonal = geometry.type === "Polygon" || geometry.type === "MultiPolygon";
    const updatedGeometry = {
      ...geometry,
      coordinates: immutablyAddPosition(geometry.coordinates, positionIndexes, positionToAdd, isPolygonal)
    };
    return this.replaceGeometry(featureIndex, updatedGeometry);
  }
  replaceGeometry(featureIndex, geometry) {
    const updatedFeature = {
      ...this.featureCollection.features[featureIndex],
      geometry
    };
    const updatedFeatureCollection = {
      ...this.featureCollection,
      features: [
        ...this.featureCollection.features.slice(0, featureIndex),
        updatedFeature,
        ...this.featureCollection.features.slice(featureIndex + 1)
      ]
    };
    return new ImmutableFeatureCollection(updatedFeatureCollection);
  }
  addFeature(feature) {
    return this.addFeatures([feature]);
  }
  addFeatures(features) {
    const updatedFeatureCollection = {
      ...this.featureCollection,
      features: [...this.featureCollection.features, ...features]
    };
    return new ImmutableFeatureCollection(updatedFeatureCollection);
  }
  deleteFeature(featureIndex) {
    return this.deleteFeatures([featureIndex]);
  }
  deleteFeatures(featureIndexes) {
    const features = [...this.featureCollection.features];
    featureIndexes.sort();
    for (let i = featureIndexes.length - 1; i >= 0; i--) {
      const featureIndex = featureIndexes[i];
      if (featureIndex >= 0 && featureIndex < features.length) {
        features.splice(featureIndex, 1);
      }
    }
    const updatedFeatureCollection = {
      ...this.featureCollection,
      features
    };
    return new ImmutableFeatureCollection(updatedFeatureCollection);
  }
};
function getUpdatedPosition(updatedPosition, previousPosition) {
  if (updatedPosition.length === 2 && previousPosition.length === 3) {
    const elevation = previousPosition[2];
    return [updatedPosition[0], updatedPosition[1], elevation];
  }
  return updatedPosition;
}
function immutablyReplacePosition(coordinates, positionIndexes, updatedPosition, isPolygonal) {
  if (!positionIndexes) {
    return coordinates;
  }
  if (positionIndexes.length === 0) {
    return getUpdatedPosition(updatedPosition, coordinates);
  }
  if (positionIndexes.length === 1) {
    const updated = [
      ...coordinates.slice(0, positionIndexes[0]),
      getUpdatedPosition(updatedPosition, coordinates[positionIndexes[0]]),
      ...coordinates.slice(positionIndexes[0] + 1)
    ];
    if (isPolygonal && (positionIndexes[0] === 0 || positionIndexes[0] === coordinates.length - 1)) {
      updated[0] = getUpdatedPosition(updatedPosition, coordinates[0]);
      updated[coordinates.length - 1] = getUpdatedPosition(updatedPosition, coordinates[0]);
    }
    return updated;
  }
  return [
    ...coordinates.slice(0, positionIndexes[0]),
    immutablyReplacePosition(coordinates[positionIndexes[0]], positionIndexes.slice(1, positionIndexes.length), updatedPosition, isPolygonal),
    ...coordinates.slice(positionIndexes[0] + 1)
  ];
}
function immutablyRemovePosition(coordinates, positionIndexes, isPolygonal) {
  if (!positionIndexes) {
    return coordinates;
  }
  if (positionIndexes.length === 0) {
    throw Error("Must specify the index of the position to remove");
  }
  if (positionIndexes.length === 1) {
    const updated = [
      ...coordinates.slice(0, positionIndexes[0]),
      ...coordinates.slice(positionIndexes[0] + 1)
    ];
    if (isPolygonal && (positionIndexes[0] === 0 || positionIndexes[0] === coordinates.length - 1)) {
      if (positionIndexes[0] === 0) {
        updated[updated.length - 1] = updated[0];
      } else if (positionIndexes[0] === coordinates.length - 1) {
        updated[0] = updated[updated.length - 1];
      }
    }
    return updated;
  }
  return [
    ...coordinates.slice(0, positionIndexes[0]),
    immutablyRemovePosition(coordinates[positionIndexes[0]], positionIndexes.slice(1, positionIndexes.length), isPolygonal),
    ...coordinates.slice(positionIndexes[0] + 1)
  ];
}
function immutablyAddPosition(coordinates, positionIndexes, positionToAdd, isPolygonal) {
  if (!positionIndexes) {
    return coordinates;
  }
  if (positionIndexes.length === 0) {
    throw Error("Must specify the index of the position to remove");
  }
  if (positionIndexes.length === 1) {
    const updated = [
      ...coordinates.slice(0, positionIndexes[0]),
      positionToAdd,
      ...coordinates.slice(positionIndexes[0])
    ];
    return updated;
  }
  return [
    ...coordinates.slice(0, positionIndexes[0]),
    immutablyAddPosition(coordinates[positionIndexes[0]], positionIndexes.slice(1, positionIndexes.length), positionToAdd, isPolygonal),
    ...coordinates.slice(positionIndexes[0] + 1)
  ];
}
function pruneGeometryIfNecessary(geometry) {
  switch (geometry.type) {
    case "Polygon":
      prunePolygonIfNecessary(geometry);
      break;
    case "MultiLineString":
      pruneMultiLineStringIfNecessary(geometry);
      break;
    case "MultiPolygon":
      pruneMultiPolygonIfNecessary(geometry);
      break;
    default:
      break;
  }
}
function prunePolygonIfNecessary(geometry) {
  const polygon3 = geometry.coordinates;
  for (let holeIndex = 1; holeIndex < polygon3.length; holeIndex++) {
    if (removeHoleIfNecessary(polygon3, holeIndex)) {
      holeIndex--;
    }
  }
}
function pruneMultiLineStringIfNecessary(geometry) {
  for (let lineStringIndex = 0; lineStringIndex < geometry.coordinates.length; lineStringIndex++) {
    const lineString3 = geometry.coordinates[lineStringIndex];
    if (lineString3.length === 1) {
      geometry.coordinates.splice(lineStringIndex, 1);
      lineStringIndex--;
    }
  }
}
function pruneMultiPolygonIfNecessary(geometry) {
  for (let polygonIndex = 0; polygonIndex < geometry.coordinates.length; polygonIndex++) {
    const polygon3 = geometry.coordinates[polygonIndex];
    const outerRing = polygon3[0];
    if (outerRing.length <= 3) {
      geometry.coordinates.splice(polygonIndex, 1);
      polygonIndex--;
    }
    for (let holeIndex = 1; holeIndex < polygon3.length; holeIndex++) {
      if (removeHoleIfNecessary(polygon3, holeIndex)) {
        holeIndex--;
      }
    }
  }
}
function removeHoleIfNecessary(polygon3, holeIndex) {
  const hole = polygon3[holeIndex];
  if (hole.length <= 3) {
    polygon3.splice(holeIndex, 1);
    return true;
  }
  return false;
}

// dist/edit-modes/geojson-edit-mode.js
var DEFAULT_GUIDES = {
  type: "FeatureCollection",
  features: []
};
var DEFAULT_TOOLTIPS = [];
var GeoJsonEditMode = class {
  _clickSequence = [];
  getGuides(props) {
    return DEFAULT_GUIDES;
  }
  getTooltips(props) {
    return DEFAULT_TOOLTIPS;
  }
  getSelectedFeature(props) {
    if (props.selectedIndexes.length === 1) {
      return props.data.features[props.selectedIndexes[0]];
    }
    return null;
  }
  getSelectedGeometry(props) {
    const feature = this.getSelectedFeature(props);
    if (feature) {
      return feature.geometry;
    }
    return null;
  }
  getSelectedFeaturesAsFeatureCollection(props) {
    const { features } = props.data;
    const selectedFeatures = props.selectedIndexes.map((selectedIndex) => features[selectedIndex]);
    return {
      type: "FeatureCollection",
      features: selectedFeatures
    };
  }
  getClickSequence() {
    return this._clickSequence;
  }
  addClickSequence({ mapCoords: mapCoords2 }) {
    this._clickSequence.push(mapCoords2);
  }
  resetClickSequence() {
    this._clickSequence = [];
  }
  getTentativeGuide(props) {
    const guides = this.getGuides(props);
    return guides.features.find((f) => f.properties && f.properties.guideType === "tentative");
  }
  isSelectionPicked(picks, props) {
    if (!picks.length)
      return false;
    const pickedFeatures = getNonGuidePicks(picks).map(({ index }) => index);
    const pickedHandles = getPickedEditHandles(picks).map(({ properties }) => properties.featureIndex);
    const pickedIndexes = /* @__PURE__ */ new Set([...pickedFeatures, ...pickedHandles]);
    return props.selectedIndexes.some((index) => pickedIndexes.has(index));
  }
  rewindPolygon(feature) {
    const { geometry } = feature;
    const isPolygonal = geometry.type === "Polygon" || geometry.type === "MultiPolygon";
    if (isPolygonal) {
      return (0, import_rewind.default)(feature);
    }
    return feature;
  }
  getAddFeatureAction(featureOrGeometry, features, featureProperties) {
    const featureOrGeometryAsAny = featureOrGeometry;
    featureProperties = featureProperties || {};
    const feature = featureOrGeometryAsAny.type === "Feature" ? featureOrGeometryAsAny : {
      type: "Feature",
      properties: featureProperties,
      geometry: featureOrGeometryAsAny
    };
    const rewindFeature = this.rewindPolygon(feature);
    const updatedData = new ImmutableFeatureCollection(features).addFeature(rewindFeature).getObject();
    return {
      updatedData,
      editType: "addFeature",
      editContext: {
        featureIndexes: [updatedData.features.length - 1]
      }
    };
  }
  getAddManyFeaturesAction({ features: featuresToAdd }, features) {
    let updatedData = new ImmutableFeatureCollection(features);
    const initialIndex = updatedData.getObject().features.length;
    const updatedIndexes = [];
    for (const feature of featuresToAdd) {
      const { properties, geometry } = feature;
      const geometryAsAny = geometry;
      updatedData = updatedData.addFeature({
        type: "Feature",
        properties,
        geometry: geometryAsAny
      });
      updatedIndexes.push(initialIndex + updatedIndexes.length);
    }
    return {
      updatedData: updatedData.getObject(),
      editType: "addFeature",
      editContext: {
        featureIndexes: updatedIndexes
      }
    };
  }
  // eslint-disable-next-line complexity
  getAddFeatureOrBooleanPolygonAction(featureOrGeometry, props, featureProperties) {
    const featureOrGeometryAsAny = featureOrGeometry;
    featureProperties = featureProperties || {};
    const selectedFeature = this.getSelectedFeature(props);
    const { modeConfig } = props;
    if (modeConfig && modeConfig.booleanOperation) {
      if (!selectedFeature || selectedFeature.geometry.type !== "Polygon" && selectedFeature.geometry.type !== "MultiPolygon") {
        console.warn("booleanOperation only supported for single Polygon or MultiPolygon selection");
        return null;
      }
      const feature = featureOrGeometryAsAny.type === "Feature" ? featureOrGeometryAsAny : {
        type: "Feature",
        geometry: featureOrGeometryAsAny
      };
      let updatedGeometry;
      if (modeConfig.booleanOperation === "union") {
        updatedGeometry = (0, import_union.default)(selectedFeature, feature);
      } else if (modeConfig.booleanOperation === "difference") {
        updatedGeometry = (0, import_difference2.default)(selectedFeature, feature);
      } else if (modeConfig.booleanOperation === "intersection") {
        updatedGeometry = (0, import_intersect.default)(selectedFeature, feature);
      } else {
        console.warn(`Invalid booleanOperation ${modeConfig.booleanOperation}`);
        return null;
      }
      if (!updatedGeometry) {
        console.warn("Canceling edit. Boolean operation erased entire polygon.");
        return null;
      }
      const featureIndex = props.selectedIndexes[0];
      const updatedData = new ImmutableFeatureCollection(props.data).replaceGeometry(featureIndex, updatedGeometry.geometry).getObject();
      const editAction = {
        updatedData,
        editType: "unionGeometry",
        editContext: {
          featureIndexes: [featureIndex]
        }
      };
      return editAction;
    }
    return this.getAddFeatureAction(featureOrGeometry, props.data, featureProperties);
  }
  createTentativeFeature(props) {
    return null;
  }
  handleClick(event, props) {
  }
  handlePointerMove(event, props) {
    const tentativeFeature = this.createTentativeFeature(props);
    if (tentativeFeature) {
      props.onEdit({
        updatedData: props.data,
        editType: "updateTentativeFeature",
        editContext: {
          feature: tentativeFeature
        }
      });
    }
  }
  handleStartDragging(event, props) {
  }
  handleStopDragging(event, props) {
  }
  handleDragging(event, props) {
  }
  handleKeyUp(event, props) {
    if (event.key === "Escape") {
      this.resetClickSequence();
      props.onEdit({
        // Because the new drawing feature is dropped, so the data will keep as the same.
        updatedData: props.data,
        editType: "cancelFeature",
        editContext: {}
      });
    }
  }
};
function getIntermediatePosition(position1, position2) {
  const intermediatePosition = [
    (position1[0] + position2[0]) / 2,
    (position1[1] + position2[1]) / 2
  ];
  return intermediatePosition;
}

// dist/edit-modes/view-mode.js
var ViewMode = class extends GeoJsonEditMode {
};

// dist/edit-modes/translate-mode.js
var import_bearing3 = __toESM(require("@turf/bearing"), 1);
var import_distance2 = __toESM(require("@turf/distance"), 1);
var import_clone = __toESM(require("@turf/clone"), 1);
var import_helpers4 = require("@turf/helpers");
var import_viewport_mercator_project3 = require("viewport-mercator-project");

// dist/utils/translate-from-center.js
var import_center = __toESM(require("@turf/center"), 1);
var import_rhumb_bearing = __toESM(require("@turf/rhumb-bearing"), 1);
var import_rhumb_distance = __toESM(require("@turf/rhumb-distance"), 1);
var import_rhumb_destination = __toESM(require("@turf/rhumb-destination"), 1);
function translateFromCenter(feature, distance7, direction) {
  const initialCenterPoint = (0, import_center.default)(feature);
  const movedCenterPoint = (0, import_rhumb_destination.default)(initialCenterPoint, distance7, direction);
  const movedCoordinates = mapCoords(feature.geometry.coordinates, (coordinate) => {
    const rhumbDistance = (0, import_rhumb_distance.default)(initialCenterPoint.geometry.coordinates, coordinate);
    const rhumbDirection = (0, import_rhumb_bearing.default)(initialCenterPoint.geometry.coordinates, coordinate);
    const movedPosition = (0, import_rhumb_destination.default)(movedCenterPoint.geometry.coordinates, rhumbDistance, rhumbDirection).geometry.coordinates;
    return movedPosition;
  });
  feature.geometry.coordinates = movedCoordinates;
  return feature;
}

// dist/edit-modes/translate-mode.js
var TranslateMode = class extends GeoJsonEditMode {
  _geometryBeforeTranslate;
  _isTranslatable = void 0;
  handleDragging(event, props) {
    if (!this._isTranslatable) {
      return;
    }
    if (this._geometryBeforeTranslate) {
      const editAction = this.getTranslateAction(event.pointerDownMapCoords, event.mapCoords, "translating", props);
      if (editAction) {
        props.onEdit(editAction);
      }
    }
    event.cancelPan();
  }
  handlePointerMove(event, props) {
    this._isTranslatable = this.isSelectionPicked(event.pointerDownPicks || event.picks, props);
    this.updateCursor(props);
  }
  handleStartDragging(event, props) {
    if (!this._isTranslatable) {
      return;
    }
    event.cancelPan();
    this._geometryBeforeTranslate = this.getSelectedFeaturesAsFeatureCollection(props);
  }
  handleStopDragging(event, props) {
    if (this._geometryBeforeTranslate) {
      const editAction = this.getTranslateAction(event.pointerDownMapCoords, event.mapCoords, "translated", props);
      if (editAction) {
        props.onEdit(editAction);
      }
      this._geometryBeforeTranslate = null;
    }
  }
  updateCursor(props) {
    if (this._isTranslatable) {
      props.onUpdateCursor("move");
    } else {
      props.onUpdateCursor(null);
    }
  }
  // eslint-disable-next-line max-statements
  getTranslateAction(startDragPoint, currentPoint, editType, props) {
    if (!this._geometryBeforeTranslate) {
      return null;
    }
    let updatedData = new ImmutableFeatureCollection(props.data);
    const selectedIndexes = props.selectedIndexes;
    const { viewport: viewportDesc, screenSpace } = props.modeConfig || {};
    if (viewportDesc && screenSpace) {
      const viewport = viewportDesc.project ? viewportDesc : new import_viewport_mercator_project3.WebMercatorViewport(viewportDesc);
      const from = viewport.project(startDragPoint);
      const to = viewport.project(currentPoint);
      const dx = to[0] - from[0];
      const dy = to[1] - from[1];
      for (let i = 0; i < selectedIndexes.length; i++) {
        const selectedIndex = selectedIndexes[i];
        const feature = this._geometryBeforeTranslate.features[i];
        let coordinates = feature.geometry.coordinates;
        if (coordinates) {
          coordinates = mapCoords(coordinates, (coord) => {
            const pixels = viewport.project(coord);
            if (pixels) {
              pixels[0] += dx;
              pixels[1] += dy;
              return viewport.unproject(pixels);
            }
            return null;
          });
          updatedData = updatedData.replaceGeometry(selectedIndex, {
            type: feature.geometry.type,
            coordinates
          });
        }
      }
    } else {
      const p1 = (0, import_helpers4.point)(startDragPoint);
      const p2 = (0, import_helpers4.point)(currentPoint);
      const distanceMoved = (0, import_distance2.default)(p1, p2);
      const direction = (0, import_bearing3.default)(p1, p2);
      const movedFeatures = this._geometryBeforeTranslate.features.map((feature) => translateFromCenter((0, import_clone.default)(feature), distanceMoved, direction));
      for (let i = 0; i < selectedIndexes.length; i++) {
        const selectedIndex = selectedIndexes[i];
        const movedFeature = movedFeatures[i];
        updatedData = updatedData.replaceGeometry(selectedIndex, movedFeature.geometry);
      }
    }
    return {
      updatedData: updatedData.getObject(),
      editType,
      editContext: {
        featureIndexes: selectedIndexes
      }
    };
  }
};

// dist/edit-modes/modify-mode.js
var import_helpers5 = require("@turf/helpers");
var ModifyMode = class extends GeoJsonEditMode {
  // eslint-disable-next-line complexity
  getGuides(props) {
    var _a;
    const handles = [];
    const { data, lastPointerMoveEvent } = props;
    const { features } = data;
    const picks = lastPointerMoveEvent && lastPointerMoveEvent.picks;
    const mapCoords2 = lastPointerMoveEvent && lastPointerMoveEvent.mapCoords;
    for (const index of props.selectedIndexes) {
      if (index < features.length) {
        const { geometry } = features[index];
        handles.push(...getEditHandlesForGeometry(geometry, index));
      } else {
        console.warn(`selectedFeatureIndexes out of range ${index}`);
      }
    }
    if (picks && picks.length && mapCoords2) {
      const existingEditHandle = getPickedExistingEditHandle(picks);
      const featureAsPick = !existingEditHandle && picks.find((pick) => !pick.isGuide);
      if (featureAsPick && !featureAsPick.object.geometry.type.includes("Point") && !(((_a = props.modeConfig) == null ? void 0 : _a.lockRectangles) && featureAsPick.object.properties.shape === "Rectangle") && props.selectedIndexes.includes(featureAsPick.index)) {
        let intermediatePoint = null;
        let positionIndexPrefix = [];
        const referencePoint = (0, import_helpers5.point)(mapCoords2);
        recursivelyTraverseNestedArrays2(featureAsPick.object.geometry.coordinates, [], (lineString3, prefix) => {
          const lineStringFeature = (0, import_helpers5.lineString)(lineString3);
          const candidateIntermediatePoint = this.getNearestPoint(
            // @ts-expect-error turf types too wide
            lineStringFeature,
            referencePoint,
            props.modeConfig && props.modeConfig.viewport
          );
          if (!intermediatePoint || candidateIntermediatePoint.properties.dist < intermediatePoint.properties.dist) {
            intermediatePoint = candidateIntermediatePoint;
            positionIndexPrefix = prefix;
          }
        });
        if (intermediatePoint) {
          const { geometry: { coordinates: position }, properties: { index } } = intermediatePoint;
          handles.push({
            type: "Feature",
            properties: {
              guideType: "editHandle",
              editHandleType: "intermediate",
              featureIndex: featureAsPick.index,
              positionIndexes: [...positionIndexPrefix, index + 1]
            },
            geometry: {
              type: "Point",
              coordinates: position
            }
          });
        }
      }
    }
    return {
      type: "FeatureCollection",
      features: handles
    };
  }
  // turf.js does not support elevation for nearestPointOnLine
  getNearestPoint(line, inPoint, viewport) {
    const { coordinates } = line.geometry;
    if (coordinates.some((coord) => coord.length > 2)) {
      if (viewport) {
        return nearestPointOnProjectedLine2(line, inPoint, viewport);
      }
      console.log("Editing 3D point but modeConfig.viewport not provided. Falling back to 2D logic.");
    }
    return nearestPointOnLine(line, inPoint, viewport);
  }
  handleClick(event, props) {
    var _a;
    const pickedExistingHandle = getPickedExistingEditHandle(event.picks);
    const pickedIntermediateHandle = getPickedIntermediateEditHandle(event.picks);
    if (pickedExistingHandle) {
      const { featureIndex, positionIndexes } = pickedExistingHandle.properties;
      let updatedData;
      try {
        updatedData = new ImmutableFeatureCollection(props.data).removePosition(featureIndex, positionIndexes).getObject();
      } catch (ignored) {
      }
      if (updatedData) {
        props.onEdit({
          updatedData,
          editType: "removePosition",
          editContext: {
            featureIndexes: [featureIndex],
            positionIndexes,
            position: pickedExistingHandle.geometry.coordinates
          }
        });
      }
    } else if (pickedIntermediateHandle) {
      const { featureIndex, positionIndexes } = pickedIntermediateHandle.properties;
      const feature = props.data.features[featureIndex];
      const canAddPosition = !(((_a = props.modeConfig) == null ? void 0 : _a.lockRectangles) && (feature == null ? void 0 : feature.properties.shape) === "Rectangle");
      if (canAddPosition) {
        const updatedData = new ImmutableFeatureCollection(props.data).addPosition(featureIndex, positionIndexes, pickedIntermediateHandle.geometry.coordinates).getObject();
        if (updatedData) {
          props.onEdit({
            updatedData,
            editType: "addPosition",
            editContext: {
              featureIndexes: [featureIndex],
              positionIndexes,
              position: pickedIntermediateHandle.geometry.coordinates
            }
          });
        }
      }
    }
  }
  handleDragging(event, props) {
    const editHandle = getPickedEditHandle(event.pointerDownPicks);
    if (editHandle) {
      event.cancelPan();
      this._dragEditHandle("movePosition", props, editHandle, event);
    }
  }
  _dragEditHandle(editType, props, editHandle, event) {
    var _a;
    const editHandleProperties = editHandle.properties;
    const editedFeature = props.data.features[editHandleProperties.featureIndex];
    let updatedData;
    if (((_a = props.modeConfig) == null ? void 0 : _a.lockRectangles) && editedFeature.properties.shape === "Rectangle") {
      const coordinates = updateRectanglePosition(editedFeature, editHandleProperties.positionIndexes[1], event.mapCoords);
      updatedData = new ImmutableFeatureCollection(props.data).replaceGeometry(editHandleProperties.featureIndex, { coordinates, type: "Polygon" }).getObject();
    } else {
      updatedData = new ImmutableFeatureCollection(props.data).replacePosition(editHandleProperties.featureIndex, editHandleProperties.positionIndexes, event.mapCoords).getObject();
    }
    props.onEdit({
      updatedData,
      editType,
      editContext: {
        featureIndexes: [editHandleProperties.featureIndex],
        positionIndexes: editHandleProperties.positionIndexes,
        position: event.mapCoords
      }
    });
  }
  handlePointerMove(event, props) {
    const cursor = this.getCursor(event);
    props.onUpdateCursor(cursor);
  }
  handleStartDragging(event, props) {
    if (shouldCancelPan(event)) {
      event.cancelPan();
    }
    const selectedFeatureIndexes = props.selectedIndexes;
    const editHandle = getPickedIntermediateEditHandle(event.picks);
    if (selectedFeatureIndexes.length && editHandle) {
      const editHandleProperties = editHandle.properties;
      const updatedData = new ImmutableFeatureCollection(props.data).addPosition(editHandleProperties.featureIndex, editHandleProperties.positionIndexes, event.mapCoords).getObject();
      props.onEdit({
        updatedData,
        editType: "addPosition",
        editContext: {
          featureIndexes: [editHandleProperties.featureIndex],
          positionIndexes: editHandleProperties.positionIndexes,
          position: event.mapCoords
        }
      });
    }
  }
  handleStopDragging(event, props) {
    const selectedFeatureIndexes = props.selectedIndexes;
    const editHandle = getPickedEditHandle(event.picks);
    if (selectedFeatureIndexes.length && editHandle) {
      this._dragEditHandle("finishMovePosition", props, editHandle, event);
    }
  }
  getCursor(event) {
    const picks = event && event.picks || [];
    const handlesPicked = getPickedEditHandles(picks);
    if (handlesPicked.length) {
      return "cell";
    }
    return null;
  }
};

// dist/edit-modes/scale-mode.js
var import_bbox2 = __toESM(require("@turf/bbox"), 1);
var import_centroid = __toESM(require("@turf/centroid"), 1);
var import_bearing4 = __toESM(require("@turf/bearing"), 1);
var import_bbox_polygon2 = __toESM(require("@turf/bbox-polygon"), 1);
var import_helpers6 = require("@turf/helpers");
var import_polygon_to_line = require("@turf/polygon-to-line");
var import_meta2 = require("@turf/meta");
var import_distance3 = __toESM(require("@turf/distance"), 1);
var import_transform_scale = __toESM(require("@turf/transform-scale"), 1);
var import_invariant2 = require("@turf/invariant");
var ScaleMode = class extends GeoJsonEditMode {
  _geometryBeingScaled;
  _selectedEditHandle;
  _cornerGuidePoints = [];
  _cursor;
  _isScaling = false;
  _isSinglePointGeometrySelected = (geometry) => {
    const { features } = geometry || {};
    if (Array.isArray(features) && features.length === 1) {
      const { type } = (0, import_invariant2.getGeom)(features[0]);
      return type === "Point";
    }
    return false;
  };
  _getOppositeScaleHandle = (selectedHandle) => {
    const selectedHandleIndex = selectedHandle && selectedHandle.properties && Array.isArray(selectedHandle.properties.positionIndexes) && selectedHandle.properties.positionIndexes[0];
    if (typeof selectedHandleIndex !== "number") {
      return null;
    }
    const guidePointCount = this._cornerGuidePoints.length;
    const oppositeIndex = (selectedHandleIndex + guidePointCount / 2) % guidePointCount;
    return this._cornerGuidePoints.find((p) => {
      if (!Array.isArray(p.properties.positionIndexes)) {
        return false;
      }
      return p.properties.positionIndexes[0] === oppositeIndex;
    }) || null;
  };
  _getUpdatedData = (props, editedData) => {
    let updatedData = new ImmutableFeatureCollection(props.data);
    const selectedIndexes = props.selectedIndexes;
    for (let i = 0; i < selectedIndexes.length; i++) {
      const selectedIndex = selectedIndexes[i];
      const movedFeature = editedData.features[i];
      updatedData = updatedData.replaceGeometry(selectedIndex, movedFeature.geometry);
    }
    return updatedData.getObject();
  };
  isEditHandleSelected = () => Boolean(this._selectedEditHandle);
  getScaleAction = (startDragPoint, currentPoint, editType, props) => {
    if (!this._selectedEditHandle) {
      return null;
    }
    const oppositeHandle = this._getOppositeScaleHandle(this._selectedEditHandle);
    const origin = (0, import_invariant2.getCoord)(oppositeHandle);
    const scaleFactor = getScaleFactor(origin, startDragPoint, currentPoint);
    const scaledFeatures = (0, import_transform_scale.default)(
      // @ts-expect-error turf types diff
      this._geometryBeingScaled,
      scaleFactor,
      { origin }
    );
    return {
      updatedData: this._getUpdatedData(props, scaledFeatures),
      editType,
      editContext: {
        featureIndexes: props.selectedIndexes
      }
    };
  };
  updateCursor = (props) => {
    if (this._selectedEditHandle) {
      if (this._cursor) {
        props.onUpdateCursor(this._cursor);
      }
      const cursorGeometry = this.getSelectedFeaturesAsFeatureCollection(props);
      const centroid = (0, import_centroid.default)(cursorGeometry);
      const bearing6 = (0, import_bearing4.default)(centroid, this._selectedEditHandle);
      const positiveBearing = bearing6 < 0 ? bearing6 + 180 : bearing6;
      if (positiveBearing >= 0 && positiveBearing <= 90 || positiveBearing >= 180 && positiveBearing <= 270) {
        this._cursor = "nesw-resize";
        props.onUpdateCursor("nesw-resize");
      } else {
        this._cursor = "nwse-resize";
        props.onUpdateCursor("nwse-resize");
      }
    } else {
      props.onUpdateCursor(null);
      this._cursor = null;
    }
  };
  handlePointerMove(event, props) {
    if (!this._isScaling) {
      const selectedEditHandle = getPickedEditHandle(event.picks);
      this._selectedEditHandle = selectedEditHandle && selectedEditHandle.properties.editHandleType === "scale" ? selectedEditHandle : null;
      this.updateCursor(props);
    }
  }
  handleStartDragging(event, props) {
    if (this._selectedEditHandle) {
      event.cancelPan();
      this._isScaling = true;
      this._geometryBeingScaled = this.getSelectedFeaturesAsFeatureCollection(props);
    }
  }
  handleDragging(event, props) {
    if (!this._isScaling) {
      return;
    }
    props.onUpdateCursor(this._cursor);
    const scaleAction = this.getScaleAction(event.pointerDownMapCoords, event.mapCoords, "scaling", props);
    if (scaleAction) {
      props.onEdit(scaleAction);
    }
    event.cancelPan();
  }
  handleStopDragging(event, props) {
    if (this._isScaling) {
      const scaleAction = this.getScaleAction(event.pointerDownMapCoords, event.mapCoords, "scaled", props);
      if (scaleAction) {
        props.onEdit(scaleAction);
      }
      props.onUpdateCursor(null);
      this._geometryBeingScaled = null;
      this._selectedEditHandle = null;
      this._cursor = null;
      this._isScaling = false;
    }
  }
  getGuides(props) {
    this._cornerGuidePoints = [];
    const selectedGeometry = this.getSelectedFeaturesAsFeatureCollection(props);
    if (this._isSinglePointGeometrySelected(selectedGeometry)) {
      return { type: "FeatureCollection", features: [] };
    }
    const boundingBox = (0, import_bbox_polygon2.default)((0, import_bbox2.default)(selectedGeometry));
    boundingBox.properties.mode = "scale";
    const cornerGuidePoints = [];
    (0, import_meta2.coordEach)(boundingBox, (coord, coordIndex) => {
      if (coordIndex < 4) {
        const cornerPoint = (0, import_helpers6.point)(coord, {
          guideType: "editHandle",
          editHandleType: "scale",
          positionIndexes: [coordIndex]
        });
        cornerGuidePoints.push(cornerPoint);
      }
    });
    this._cornerGuidePoints = cornerGuidePoints;
    return (0, import_helpers6.featureCollection)([(0, import_polygon_to_line.polygonToLine)(boundingBox), ...this._cornerGuidePoints]);
  }
};
function getScaleFactor(centroid, startDragPoint, currentPoint) {
  const startDistance = (0, import_distance3.default)(centroid, startDragPoint);
  const endDistance = (0, import_distance3.default)(centroid, currentPoint);
  return endDistance / startDistance;
}

// dist/edit-modes/rotate-mode.js
var import_bbox3 = __toESM(require("@turf/bbox"), 1);
var import_centroid2 = __toESM(require("@turf/centroid"), 1);
var import_bearing5 = __toESM(require("@turf/bearing"), 1);
var import_bbox_polygon3 = __toESM(require("@turf/bbox-polygon"), 1);
var import_distance4 = __toESM(require("@turf/distance"), 1);
var import_meta3 = require("@turf/meta");
var import_invariant3 = require("@turf/invariant");
var import_helpers7 = require("@turf/helpers");
var import_transform_rotate = __toESM(require("@turf/transform-rotate"), 1);
var import_polygon_to_line2 = require("@turf/polygon-to-line");
var RotateMode = class extends GeoJsonEditMode {
  _selectedEditHandle;
  _geometryBeingRotated;
  _isRotating = false;
  _isSinglePointGeometrySelected = (geometry) => {
    const { features } = geometry || {};
    if (Array.isArray(features) && features.length === 1) {
      const { type } = (0, import_invariant3.getGeom)(features[0]);
      return type === "Point";
    }
    return false;
  };
  getIsRotating = () => this._isRotating;
  getGuides(props) {
    const selectedGeometry = this._geometryBeingRotated || this.getSelectedFeaturesAsFeatureCollection(props);
    if (this._isSinglePointGeometrySelected(selectedGeometry)) {
      return { type: "FeatureCollection", features: [] };
    }
    if (this._isRotating) {
      return (0, import_helpers7.featureCollection)([(0, import_centroid2.default)(selectedGeometry)]);
    }
    const boundingBox = (0, import_bbox_polygon3.default)((0, import_bbox3.default)(selectedGeometry));
    let previousCoord = null;
    let topEdgeMidpointCoords = null;
    let longestEdgeLength = 0;
    (0, import_meta3.coordEach)(boundingBox, (coord) => {
      if (previousCoord) {
        const edgeMidpoint = getIntermediatePosition(coord, previousCoord);
        if (!topEdgeMidpointCoords || edgeMidpoint[1] > topEdgeMidpointCoords[1]) {
          topEdgeMidpointCoords = edgeMidpoint;
        }
        const edgeDistance = (0, import_distance4.default)(coord, previousCoord);
        longestEdgeLength = Math.max(longestEdgeLength, edgeDistance);
      }
      previousCoord = coord;
    });
    const rotateHandleCoords = topEdgeMidpointCoords && [
      topEdgeMidpointCoords[0],
      topEdgeMidpointCoords[1] + longestEdgeLength / 1e3
    ];
    const lineFromEnvelopeToRotateHandle = (0, import_helpers7.lineString)([topEdgeMidpointCoords, rotateHandleCoords]);
    const rotateHandle = (0, import_helpers7.point)(rotateHandleCoords, {
      guideType: "editHandle",
      editHandleType: "rotate"
    });
    const outFeatures = [(0, import_polygon_to_line2.polygonToLine)(boundingBox), rotateHandle, lineFromEnvelopeToRotateHandle];
    return (0, import_helpers7.featureCollection)(outFeatures);
  }
  handleDragging(event, props) {
    if (!this._isRotating) {
      return;
    }
    const rotateAction = this.getRotateAction(event.pointerDownMapCoords, event.mapCoords, "rotating", props);
    if (rotateAction) {
      props.onEdit(rotateAction);
    }
    event.cancelPan();
  }
  handlePointerMove(event, props) {
    if (!this._isRotating) {
      const selectedEditHandle = getPickedEditHandle(event.picks);
      this._selectedEditHandle = selectedEditHandle && selectedEditHandle.properties.editHandleType === "rotate" ? selectedEditHandle : null;
    }
    this.updateCursor(props);
  }
  handleStartDragging(event, props) {
    if (this._selectedEditHandle) {
      event.cancelPan();
      this._isRotating = true;
      this._geometryBeingRotated = this.getSelectedFeaturesAsFeatureCollection(props);
    }
  }
  handleStopDragging(event, props) {
    if (this._isRotating) {
      const rotateAction = this.getRotateAction(event.pointerDownMapCoords, event.mapCoords, "rotated", props);
      if (rotateAction) {
        props.onEdit(rotateAction);
      }
      this._geometryBeingRotated = null;
      this._selectedEditHandle = null;
      this._isRotating = false;
    }
  }
  updateCursor(props) {
    if (this._selectedEditHandle) {
      props.onUpdateCursor("crosshair");
    } else {
      props.onUpdateCursor(null);
    }
  }
  getRotateAction(startDragPoint, currentPoint, editType, props) {
    if (!this._geometryBeingRotated) {
      return null;
    }
    const centroid = (0, import_centroid2.default)(this._geometryBeingRotated);
    const angle = getRotationAngle(centroid, startDragPoint, currentPoint);
    const rotatedFeatures = (0, import_transform_rotate.default)(
      // @ts-expect-error turf types too wide
      this._geometryBeingRotated,
      angle,
      {
        pivot: centroid
      }
    );
    let updatedData = new ImmutableFeatureCollection(props.data);
    const selectedIndexes = props.selectedIndexes;
    for (let i = 0; i < selectedIndexes.length; i++) {
      const selectedIndex = selectedIndexes[i];
      const movedFeature = rotatedFeatures.features[i];
      updatedData = updatedData.replaceGeometry(selectedIndex, movedFeature.geometry);
    }
    return {
      updatedData: updatedData.getObject(),
      editType,
      editContext: {
        featureIndexes: selectedIndexes
      }
    };
  }
};
function getRotationAngle(centroid, startDragPoint, currentPoint) {
  const bearing1 = (0, import_bearing5.default)(centroid, startDragPoint);
  const bearing22 = (0, import_bearing5.default)(centroid, currentPoint);
  return bearing22 - bearing1;
}

// dist/edit-modes/duplicate-mode.js
var DuplicateMode = class extends TranslateMode {
  handleStartDragging(event, props) {
    super.handleStartDragging(event, props);
    if (this._geometryBeforeTranslate) {
      props.onEdit(this.getAddManyFeaturesAction(this._geometryBeforeTranslate, props.data));
    }
  }
  updateCursor(props) {
    if (this._isTranslatable) {
      props.onUpdateCursor("copy");
    } else {
      props.onUpdateCursor(null);
    }
  }
};

// dist/edit-modes/split-polygon-mode.js
var import_boolean_point_in_polygon = __toESM(require("@turf/boolean-point-in-polygon"), 1);
var import_difference3 = __toESM(require("@turf/difference"), 1);
var import_buffer2 = __toESM(require("@turf/buffer"), 1);
var import_line_intersect = __toESM(require("@turf/line-intersect"), 1);
var import_helpers8 = require("@turf/helpers");
var import_bearing6 = __toESM(require("@turf/bearing"), 1);
var import_distance5 = __toESM(require("@turf/distance"), 1);
var import_destination3 = __toESM(require("@turf/destination"), 1);
var import_polygon_to_line3 = __toESM(require("@turf/polygon-to-line"), 1);
var import_nearest_point_on_line = __toESM(require("@turf/nearest-point-on-line"), 1);
var SplitPolygonMode = class extends GeoJsonEditMode {
  calculateMapCoords(clickSequence, mapCoords2, props) {
    const modeConfig = props.modeConfig;
    if (!modeConfig || !modeConfig.lock90Degree || !clickSequence.length) {
      return mapCoords2;
    }
    if (clickSequence.length === 1) {
      const firstPoint = clickSequence[0];
      const selectedGeometry = this.getSelectedGeometry(props);
      const feature = (0, import_polygon_to_line3.default)(selectedGeometry);
      const lines = feature.type === "FeatureCollection" ? feature.features : [feature];
      let minDistance = Number.MAX_SAFE_INTEGER;
      let closestPoint = null;
      lines.forEach((line) => {
        const snapPoint = (0, import_nearest_point_on_line.default)(line, firstPoint);
        const distanceFromOrigin = (0, import_distance5.default)(snapPoint, firstPoint);
        if (minDistance > distanceFromOrigin) {
          minDistance = distanceFromOrigin;
          closestPoint = snapPoint;
        }
      });
      if (closestPoint) {
        const lastBearing = (0, import_bearing6.default)(firstPoint, closestPoint);
        const currentDistance = (0, import_distance5.default)(firstPoint, mapCoords2, { units: "meters" });
        return (0, import_destination3.default)(firstPoint, currentDistance, lastBearing, {
          units: "meters"
        }).geometry.coordinates;
      }
      return mapCoords2;
    }
    const lastPoint = clickSequence[clickSequence.length - 1];
    const [approximatePoint] = generatePointsParallelToLinePoints2(clickSequence[clickSequence.length - 2], lastPoint, mapCoords2);
    const nearestPt = (0, import_nearest_point_on_line.default)((0, import_helpers8.lineString)([lastPoint, approximatePoint]), mapCoords2).geometry.coordinates;
    return nearestPt;
  }
  getGuides(props) {
    const clickSequence = this.getClickSequence();
    const guides = {
      type: "FeatureCollection",
      features: []
    };
    if (clickSequence.length === 0 || !props.lastPointerMoveEvent) {
      return guides;
    }
    const { mapCoords: mapCoords2 } = props.lastPointerMoveEvent;
    guides.features.push({
      type: "Feature",
      properties: {
        guideType: "tentative"
      },
      geometry: {
        type: "LineString",
        coordinates: [...clickSequence, this.calculateMapCoords(clickSequence, mapCoords2, props)]
      }
    });
    return guides;
  }
  handleClick(event, props) {
    const tentativeFeature = this.getTentativeGuide(props);
    const selectedGeometry = this.getSelectedGeometry(props);
    if (!selectedGeometry) {
      console.warn("A polygon must be selected for splitting");
      return;
    }
    const clickSequence = this.getClickSequence();
    if (tentativeFeature && tentativeFeature.geometry.type === "LineString") {
      clickSequence.push(tentativeFeature.geometry.coordinates[tentativeFeature.geometry.coordinates.length - 1]);
    } else {
      this.addClickSequence(event);
    }
    const pt = {
      type: "Point",
      coordinates: clickSequence[clickSequence.length - 1]
    };
    const isPointInPolygon = (0, import_boolean_point_in_polygon.default)(pt, selectedGeometry);
    if (clickSequence.length > 1 && tentativeFeature && !isPointInPolygon) {
      this.resetClickSequence();
      const isLineInterectingWithPolygon = (0, import_line_intersect.default)(tentativeFeature, selectedGeometry);
      if (isLineInterectingWithPolygon.features.length === 0) {
        return;
      }
      const editAction = this.splitPolygon(tentativeFeature, props);
      if (editAction) {
        props.onEdit(editAction);
      }
    }
  }
  handlePointerMove(event, props) {
    props.onUpdateCursor("cell");
  }
  splitPolygon(tentativeFeature, props) {
    const selectedGeometry = this.getSelectedGeometry(props);
    const featureIndex = props.selectedIndexes[0];
    const modeConfig = props.modeConfig || {};
    let { gap = 0.1, units = "centimeters" } = modeConfig;
    if (gap === 0) {
      gap = 0.1;
      units = "centimeters";
    }
    const buffer = (0, import_buffer2.default)(tentativeFeature, gap, { units });
    const updatedGeometry = (0, import_difference3.default)(selectedGeometry, buffer);
    if (!updatedGeometry) {
      console.warn("Canceling edit. Split Polygon erased");
      return null;
    }
    const { type, coordinates } = updatedGeometry.geometry;
    let updatedCoordinates = [];
    if (type === "Polygon") {
      updatedCoordinates = coordinates.map((c) => [c]);
    } else {
      updatedCoordinates = coordinates.reduce((agg, prev) => {
        prev.forEach((p) => {
          agg.push([p]);
        });
        return agg;
      }, []);
    }
    const updatedData = new ImmutableFeatureCollection(props.data).replaceGeometry(featureIndex, {
      type: "MultiPolygon",
      coordinates: updatedCoordinates
    });
    const editAction = {
      updatedData: updatedData.getObject(),
      editType: "split",
      editContext: {
        featureIndexes: [featureIndex]
      }
    };
    return editAction;
  }
};

// dist/edit-modes/extrude-mode.js
var import_bearing7 = __toESM(require("@turf/bearing"), 1);
var ExtrudeMode = class extends ModifyMode {
  // this mode is busted =(
  isPointAdded = false;
  handleDragging(event, props) {
    const editHandle = getPickedEditHandle(event.pointerDownPicks);
    if (editHandle) {
      const { featureIndex } = editHandle.properties;
      let { positionIndexes } = editHandle.properties;
      const size = this.coordinatesSize(positionIndexes, featureIndex, props.data);
      positionIndexes = this.isPointAdded ? this.nextPositionIndexes(positionIndexes, size) : positionIndexes;
      const p1 = this.getPointForPositionIndexes(this.prevPositionIndexes(positionIndexes, size), featureIndex, props.data);
      const p2 = this.getPointForPositionIndexes(positionIndexes, featureIndex, props.data);
      if (p1 && p2) {
        const [p3, p4] = generatePointsParallelToLinePoints2(p1, p2, event.mapCoords);
        const updatedData = new ImmutableFeatureCollection(props.data).replacePosition(featureIndex, this.prevPositionIndexes(positionIndexes, size), p4).replacePosition(featureIndex, positionIndexes, p3).getObject();
        props.onEdit({
          updatedData,
          editType: "extruding",
          editContext: {
            featureIndexes: [featureIndex],
            positionIndexes: this.nextPositionIndexes(positionIndexes, size),
            position: p3
          }
        });
        event.cancelPan();
      }
    }
  }
  handleStartDragging(event, props) {
    if (shouldCancelPan(event)) {
      event.cancelPan();
    }
    const selectedFeatureIndexes = props.selectedIndexes;
    const editHandle = getPickedIntermediateEditHandle(event.picks);
    if (selectedFeatureIndexes.length && editHandle) {
      const { positionIndexes, featureIndex } = editHandle.properties;
      const size = this.coordinatesSize(positionIndexes, featureIndex, props.data);
      const p1 = this.getPointForPositionIndexes(this.prevPositionIndexes(positionIndexes, size), featureIndex, props.data);
      const p2 = this.getPointForPositionIndexes(positionIndexes, featureIndex, props.data);
      if (p1 && p2) {
        let updatedData = new ImmutableFeatureCollection(props.data);
        if (!this.isOrthogonal(positionIndexes, featureIndex, size, props.data)) {
          updatedData = updatedData.addPosition(featureIndex, positionIndexes, p2);
        }
        if (!this.isOrthogonal(this.prevPositionIndexes(positionIndexes, size), featureIndex, size, props.data)) {
          updatedData = updatedData.addPosition(featureIndex, positionIndexes, p1);
          this.isPointAdded = true;
        }
        props.onEdit({
          updatedData: updatedData.getObject(),
          editType: "startExtruding",
          editContext: {
            featureIndexes: [featureIndex],
            positionIndexes,
            position: p1
          }
        });
      }
    }
  }
  handleStopDragging(event, props) {
    const selectedFeatureIndexes = props.selectedIndexes;
    const editHandle = getPickedEditHandle(event.pointerDownPicks);
    if (selectedFeatureIndexes.length && editHandle) {
      const { featureIndex } = editHandle.properties;
      let { positionIndexes } = editHandle.properties;
      const size = this.coordinatesSize(positionIndexes, featureIndex, props.data);
      positionIndexes = this.isPointAdded ? this.nextPositionIndexes(positionIndexes, size) : positionIndexes;
      const p1 = this.getPointForPositionIndexes(this.prevPositionIndexes(positionIndexes, size), featureIndex, props.data);
      const p2 = this.getPointForPositionIndexes(positionIndexes, featureIndex, props.data);
      if (p1 && p2) {
        const [p3, p4] = generatePointsParallelToLinePoints2(p1, p2, event.mapCoords);
        const updatedData = new ImmutableFeatureCollection(props.data).replacePosition(featureIndex, this.prevPositionIndexes(positionIndexes, size), p4).replacePosition(featureIndex, positionIndexes, p3).getObject();
        props.onEdit({
          updatedData,
          editType: "extruded",
          editContext: {
            featureIndexes: [featureIndex],
            positionIndexes,
            position: p3
          }
        });
      }
    }
    this.isPointAdded = false;
  }
  coordinatesSize(positionIndexes, featureIndex, { features }) {
    let size = 0;
    if (Array.isArray(positionIndexes)) {
      const feature = features[featureIndex];
      const coordinates = feature.geometry.coordinates;
      if (positionIndexes.length === 3) {
        const [a, b] = positionIndexes;
        if (coordinates.length && coordinates[a].length) {
          size = coordinates[a][b].length;
        }
      } else {
        const [b] = positionIndexes;
        if (coordinates.length && coordinates[b].length) {
          size = coordinates[b].length;
        }
      }
    }
    return size;
  }
  getBearing(p1, p2) {
    const angle = (0, import_bearing7.default)(p1, p2);
    if (angle < 0) {
      return Math.floor(360 + angle);
    }
    return Math.floor(angle);
  }
  isOrthogonal(positionIndexes, featureIndex, size, features) {
    if (!Array.isArray(positionIndexes)) {
      return false;
    }
    if (positionIndexes[positionIndexes.length - 1] === size - 1) {
      positionIndexes[positionIndexes.length - 1] = 0;
    }
    const prevPoint = this.getPointForPositionIndexes(this.prevPositionIndexes(positionIndexes, size), featureIndex, features);
    const nextPoint = this.getPointForPositionIndexes(this.nextPositionIndexes(positionIndexes, size), featureIndex, features);
    const currentPoint = this.getPointForPositionIndexes(positionIndexes, featureIndex, features);
    const prevAngle = this.getBearing(currentPoint, prevPoint);
    const nextAngle = this.getBearing(currentPoint, nextPoint);
    return [89, 90, 91, 269, 270, 271].includes(Math.abs(prevAngle - nextAngle));
  }
  nextPositionIndexes(positionIndexes, size) {
    if (!Array.isArray(positionIndexes)) {
      return [];
    }
    const next = [...positionIndexes];
    if (next.length) {
      next[next.length - 1] = next[next.length - 1] === size - 1 ? 0 : next[next.length - 1] + 1;
    }
    return next;
  }
  prevPositionIndexes(positionIndexes, size) {
    if (!Array.isArray(positionIndexes)) {
      return [];
    }
    const prev = [...positionIndexes];
    if (prev.length) {
      prev[prev.length - 1] = prev[prev.length - 1] === 0 ? size - 2 : prev[prev.length - 1] - 1;
    }
    return prev;
  }
  getPointForPositionIndexes(positionIndexes, featureIndex, { features }) {
    let p1;
    if (Array.isArray(positionIndexes)) {
      const feature = features[featureIndex];
      const coordinates = feature.geometry.coordinates;
      if (positionIndexes.length === 3) {
        const [a, b, c] = positionIndexes;
        if (coordinates.length && coordinates[a].length) {
          p1 = coordinates[a][b][c];
        }
      } else {
        const [b, c] = positionIndexes;
        if (coordinates.length && coordinates[b].length) {
          p1 = coordinates[b][c];
        }
      }
    }
    return p1;
  }
};

// dist/edit-modes/elevation-mode.js
function defaultCalculateElevationChange({ pointerDownScreenCoords, screenCoords }) {
  return 10 * (pointerDownScreenCoords[1] - screenCoords[1]);
}
var ElevationMode = class extends ModifyMode {
  makeElevatedEvent(event, position, props) {
    const { minElevation = 0, maxElevation = 2e4, calculateElevationChange = defaultCalculateElevationChange } = props.modeConfig || {};
    if (!event.pointerDownScreenCoords) {
      return event;
    }
    let elevation = position.length === 3 ? position[2] : 0;
    elevation += calculateElevationChange({
      pointerDownScreenCoords: event.pointerDownScreenCoords,
      screenCoords: event.screenCoords
    });
    elevation = Math.min(elevation, maxElevation);
    elevation = Math.max(elevation, minElevation);
    return Object.assign({}, event, {
      mapCoords: [position[0], position[1], elevation]
    });
  }
  handlePointerMove(event, props) {
    const editHandle = getPickedEditHandle(event.pointerDownPicks);
    const position = editHandle ? editHandle.geometry.coordinates : event.mapCoords;
    super.handlePointerMove(this.makeElevatedEvent(event, position, props), props);
  }
  handleStopDragging(event, props) {
    const editHandle = getPickedEditHandle(event.picks);
    const position = editHandle ? editHandle.geometry.coordinates : event.mapCoords;
    super.handleStopDragging(this.makeElevatedEvent(event, position, props), props);
  }
  getCursor(event) {
    let cursor = super.getCursor(event);
    if (cursor === "cell") {
      cursor = "ns-resize";
    }
    return cursor;
  }
  static calculateElevationChangeWithViewport(viewport, { pointerDownScreenCoords, screenCoords }) {
    const metersPerPixel = 156543.03392 * Math.cos(viewport.latitude * Math.PI / 180) / Math.pow(2, viewport.zoom);
    return metersPerPixel * (pointerDownScreenCoords[1] - screenCoords[1]) / 2;
  }
};

// dist/edit-modes/draw-point-mode.js
var DrawPointMode = class extends GeoJsonEditMode {
  createTentativeFeature(props) {
    const { lastPointerMoveEvent } = props;
    const lastCoords = lastPointerMoveEvent ? [lastPointerMoveEvent.mapCoords] : [];
    return {
      type: "Feature",
      properties: {
        guideType: "tentative"
      },
      geometry: {
        type: "Point",
        coordinates: lastCoords[0]
      }
    };
  }
  handleClick({ mapCoords: mapCoords2 }, props) {
    const geometry = {
      type: "Point",
      coordinates: mapCoords2
    };
    props.onEdit(this.getAddFeatureAction(geometry, props.data));
  }
  handlePointerMove(event, props) {
    props.onUpdateCursor("cell");
    super.handlePointerMove(event, props);
  }
};

// dist/edit-modes/draw-line-string-mode.js
var import_distance6 = __toESM(require("@turf/distance"), 1);

// dist/utils/memoize.js
function isEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (Array.isArray(a)) {
    const len = a.length;
    if (!b || b.length !== len) {
      return false;
    }
    for (let i = 0; i < len; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  }
  return false;
}
function memoize(compute) {
  let cachedArgs = {};
  let cachedResult;
  return (args) => {
    for (const key in args) {
      if (!isEqual(args[key], cachedArgs[key])) {
        cachedResult = compute(args);
        cachedArgs = args;
        break;
      }
    }
    return cachedResult;
  };
}

// dist/edit-modes/draw-line-string-mode.js
var DrawLineStringMode = class extends GeoJsonEditMode {
  // declaration of variables for the calculation of the distance of linestring
  dist = 0;
  position = null;
  elems = [];
  handleClick(event, props) {
    const { picks } = event;
    const clickedEditHandle = getPickedEditHandle(picks);
    let positionAdded = false;
    if (!clickedEditHandle) {
      this.addClickSequence(event);
      positionAdded = true;
    }
    const clickSequence = this.getClickSequence();
    if (!clickedEditHandle) {
      this.calculateInfoDraw(clickSequence);
    }
    if (clickSequence.length > 1 && clickedEditHandle && Array.isArray(clickedEditHandle.properties.positionIndexes) && clickedEditHandle.properties.positionIndexes[0] === clickSequence.length - 1) {
      this.dist = 0;
      const lineStringToAdd = {
        type: "LineString",
        coordinates: [...clickSequence]
      };
      this.resetClickSequence();
      const editAction = this.getAddFeatureAction(lineStringToAdd, props.data);
      if (editAction) {
        props.onEdit(editAction);
      }
    } else if (positionAdded) {
      props.onEdit({
        // data is the same
        updatedData: props.data,
        editType: "addTentativePosition",
        editContext: {
          position: event.mapCoords
        }
      });
    }
  }
  handleKeyUp(event, props) {
    const { key } = event;
    if (key === "Enter") {
      const clickSequence = this.getClickSequence();
      if (clickSequence.length > 1) {
        const lineStringToAdd = {
          type: "LineString",
          coordinates: [...clickSequence]
        };
        this.resetClickSequence();
        const editAction = this.getAddFeatureAction(lineStringToAdd, props.data);
        if (editAction) {
          props.onEdit(editAction);
        }
      }
    } else if (key === "Escape") {
      this.resetClickSequence();
      props.onEdit({
        // Because the new drawing feature is dropped, so the data will keep as the same.
        updatedData: props.data,
        editType: "cancelFeature",
        editContext: {}
      });
    }
  }
  getGuides(props) {
    const { lastPointerMoveEvent } = props;
    const clickSequence = this.getClickSequence();
    const lastCoords = lastPointerMoveEvent ? [lastPointerMoveEvent.mapCoords] : [];
    const guides = {
      type: "FeatureCollection",
      features: []
    };
    let tentativeFeature;
    if (clickSequence.length > 0) {
      tentativeFeature = {
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [...clickSequence, ...lastCoords]
        }
      };
    }
    if (tentativeFeature) {
      guides.features.push(tentativeFeature);
    }
    const editHandles = clickSequence.map((clickedCoord, index) => ({
      type: "Feature",
      properties: {
        guideType: "editHandle",
        editHandleType: "existing",
        featureIndex: -1,
        positionIndexes: [index]
      },
      geometry: {
        type: "Point",
        coordinates: clickedCoord
      }
    }));
    guides.features.push(...editHandles);
    return guides;
  }
  handlePointerMove(event, props) {
    props.onUpdateCursor("cell");
  }
  /**
   * define the default function to display the tooltip for
   * nebula geometry mode type
   * @param props properties of geometry nebula mode
   */
  getTooltips(props) {
    return this._getTooltips({
      modeConfig: props.modeConfig,
      dist: this.dist
    });
  }
  // utility function
  calculateInfoDraw(clickSequence) {
    if (clickSequence.length > 1) {
      this.position = clickSequence[clickSequence.length - 1];
      this.dist += (0, import_distance6.default)(clickSequence[clickSequence.length - 2], clickSequence[clickSequence.length - 1]);
    }
  }
  /**
   * redefine the tooltip of geometry
   * @param modeConfig
   * @param dist
   */
  _getTooltips = memoize(({ modeConfig, dist }) => {
    let tooltips = [];
    const { formatTooltip } = modeConfig || {};
    let text;
    if (dist) {
      if (formatTooltip) {
        text = formatTooltip(dist);
      } else {
        text = `Distance: ${parseFloat(dist).toFixed(2)} kilometers`;
      }
      tooltips = [
        {
          position: this.position,
          text
        }
      ];
    }
    return tooltips;
  });
};

// dist/edit-modes/draw-polygon-mode.js
var import_line_intersect2 = __toESM(require("@turf/line-intersect"), 1);
var import_helpers9 = require("@turf/helpers");
var DrawPolygonMode = class extends GeoJsonEditMode {
  createTentativeFeature(props) {
    const { lastPointerMoveEvent } = props;
    const clickSequence = this.getClickSequence();
    const lastCoords = lastPointerMoveEvent ? [lastPointerMoveEvent.mapCoords] : [];
    let tentativeFeature;
    if (clickSequence.length === 1 || clickSequence.length === 2) {
      tentativeFeature = {
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [...clickSequence, ...lastCoords]
        }
      };
    } else if (clickSequence.length > 2) {
      tentativeFeature = {
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "Polygon",
          coordinates: [[...clickSequence, ...lastCoords, clickSequence[0]]]
        }
      };
    }
    return tentativeFeature;
  }
  getGuides(props) {
    const clickSequence = this.getClickSequence();
    const guides = {
      type: "FeatureCollection",
      features: []
    };
    const tentativeFeature = this.createTentativeFeature(props);
    if (tentativeFeature) {
      guides.features.push(tentativeFeature);
    }
    const editHandles = clickSequence.map((clickedCoord, index) => ({
      type: "Feature",
      properties: {
        guideType: "editHandle",
        editHandleType: "existing",
        featureIndex: -1,
        positionIndexes: [index]
      },
      geometry: {
        type: "Point",
        coordinates: clickedCoord
      }
    }));
    guides.features.push(...editHandles);
    return guides;
  }
  // eslint-disable-next-line complexity
  handleClick(event, props) {
    const { picks } = event;
    const clickedEditHandle = getPickedEditHandle(picks);
    const clickSequence = this.getClickSequence();
    let overlappingLines = false;
    if (clickSequence.length > 2 && props.modeConfig && props.modeConfig.preventOverlappingLines) {
      const currentLine = (0, import_helpers9.lineString)([
        clickSequence[clickSequence.length - 1],
        event.mapCoords
      ]);
      const otherLines = (0, import_helpers9.lineString)([...clickSequence.slice(0, clickSequence.length - 1)]);
      const intersectingPoints = (0, import_line_intersect2.default)(currentLine, otherLines);
      if (intersectingPoints.features.length > 0) {
        overlappingLines = true;
      }
    }
    let positionAdded = false;
    if (!clickedEditHandle && !overlappingLines) {
      this.addClickSequence(event);
      positionAdded = true;
    }
    if (clickSequence.length > 2 && clickedEditHandle && Array.isArray(clickedEditHandle.properties.positionIndexes) && (clickedEditHandle.properties.positionIndexes[0] === 0 || clickedEditHandle.properties.positionIndexes[0] === clickSequence.length - 1)) {
      const polygonToAdd = {
        type: "Polygon",
        coordinates: [[...clickSequence, clickSequence[0]]]
      };
      this.resetClickSequence();
      const editAction = this.getAddFeatureOrBooleanPolygonAction(polygonToAdd, props);
      if (editAction) {
        props.onEdit(editAction);
      }
    } else if (positionAdded) {
      props.onEdit({
        // data is the same
        updatedData: props.data,
        editType: "addTentativePosition",
        editContext: {
          position: event.mapCoords
        }
      });
    }
  }
  handleKeyUp(event, props) {
    if (event.key === "Enter") {
      const clickSequence = this.getClickSequence();
      if (clickSequence.length > 2) {
        const polygonToAdd = {
          type: "Polygon",
          coordinates: [[...clickSequence, clickSequence[0]]]
        };
        this.resetClickSequence();
        const editAction = this.getAddFeatureOrBooleanPolygonAction(polygonToAdd, props);
        if (editAction) {
          props.onEdit(editAction);
        }
      }
    } else if (event.key === "Escape") {
      this.resetClickSequence();
      props.onEdit({
        // Because the new drawing feature is dropped, so the data will keep as the same.
        updatedData: props.data,
        editType: "cancelFeature",
        editContext: {}
      });
    }
  }
  handlePointerMove(event, props) {
    props.onUpdateCursor("cell");
    super.handlePointerMove(event, props);
  }
};

// dist/edit-modes/draw-rectangle-mode.js
var import_bbox_polygon4 = __toESM(require("@turf/bbox-polygon"), 1);

// dist/edit-modes/two-click-polygon-mode.js
var import_lodash = __toESM(require("lodash.omit"), 1);
var TwoClickPolygonMode = class extends GeoJsonEditMode {
  handleClick(event, props) {
    if (props.modeConfig && props.modeConfig.dragToDraw) {
      return;
    }
    this.addClickSequence(event);
    this.checkAndFinishPolygon(props);
  }
  handleStartDragging(event, props) {
    if (!props.modeConfig || !props.modeConfig.dragToDraw) {
      return;
    }
    this.addClickSequence(event);
    event.cancelPan();
  }
  handleStopDragging(event, props) {
    if (!props.modeConfig || !props.modeConfig.dragToDraw) {
      return;
    }
    this.addClickSequence(event);
    this.checkAndFinishPolygon(props);
  }
  checkAndFinishPolygon(props) {
    const clickSequence = this.getClickSequence();
    const tentativeFeature = this.getTentativeGuide(props);
    if (clickSequence.length > 1 && tentativeFeature && tentativeFeature.geometry.type === "Polygon") {
      const feature = {
        type: "Feature",
        properties: (0, import_lodash.default)(tentativeFeature.properties, "guideType"),
        geometry: {
          type: "Polygon",
          coordinates: tentativeFeature.geometry.coordinates
        }
      };
      const editAction = this.getAddFeatureOrBooleanPolygonAction(feature, props);
      this.resetClickSequence();
      if (editAction) {
        props.onEdit(editAction);
      }
    }
  }
  getGuides(props) {
    const { lastPointerMoveEvent, modeConfig } = props;
    const clickSequence = this.getClickSequence();
    const guides = {
      type: "FeatureCollection",
      features: []
    };
    if (clickSequence.length === 0 || !lastPointerMoveEvent) {
      return guides;
    }
    const corner1 = clickSequence[0];
    const corner2 = lastPointerMoveEvent.mapCoords;
    const polygon3 = this.getTwoClickPolygon(corner1, corner2, modeConfig);
    if (polygon3) {
      guides.features.push({
        type: "Feature",
        properties: {
          ...polygon3.properties,
          guideType: "tentative"
        },
        geometry: polygon3.geometry
      });
    }
    return guides;
  }
  getTwoClickPolygon(coord1, coord2, modeConfig) {
    return null;
  }
  handlePointerMove(event, props) {
    props.onUpdateCursor("cell");
    super.handlePointerMove(event, props);
  }
  createTentativeFeature(props) {
    const { lastPointerMoveEvent } = props;
    const clickSequence = this.getClickSequence();
    const lastCoords = lastPointerMoveEvent ? [lastPointerMoveEvent.mapCoords] : [];
    let tentativeFeature;
    if (clickSequence.length === 1) {
      tentativeFeature = this.getTwoClickPolygon(clickSequence[0], lastCoords[0], props.modeConfig);
    }
    return tentativeFeature;
  }
};

// dist/edit-modes/draw-rectangle-mode.js
var DrawRectangleMode = class extends TwoClickPolygonMode {
  getTwoClickPolygon(coord1, coord2, modeConfig) {
    const rectangle = (0, import_bbox_polygon4.default)([coord1[0], coord1[1], coord2[0], coord2[1]]);
    rectangle.properties = rectangle.properties || {};
    rectangle.properties.shape = "Rectangle";
    return rectangle;
  }
};

// dist/edit-modes/draw-square-mode.js
var import_bbox_polygon5 = __toESM(require("@turf/bbox-polygon"), 1);
var import_distance7 = __toESM(require("@turf/distance"), 1);
var import_along = __toESM(require("@turf/along"), 1);
var import_helpers10 = require("@turf/helpers");
var DrawSquareMode = class extends TwoClickPolygonMode {
  getTwoClickPolygon(coord1, coord2, modeConfig) {
    const coord3 = [coord2[0], coord1[1]];
    const coord4 = [coord1[0], coord2[1]];
    const distance1 = (0, import_distance7.default)((0, import_helpers10.point)(coord3), (0, import_helpers10.point)(coord1));
    const distance22 = (0, import_distance7.default)((0, import_helpers10.point)(coord4), (0, import_helpers10.point)(coord1));
    const shortestDistance = distance1 <= distance22 ? distance1 : distance22;
    const closestPoint = distance1 <= distance22 ? coord3 : coord4;
    const line = (0, import_helpers10.lineString)([closestPoint, coord2]);
    const newPoint = (0, import_along.default)(line, shortestDistance);
    const corner = newPoint.geometry.coordinates;
    const square = (0, import_bbox_polygon5.default)([coord1[0], coord1[1], corner[0], corner[1]]);
    square.properties = square.properties || {};
    square.properties.shape = "Square";
    return square;
  }
};

// dist/edit-modes/draw-rectangle-from-center-mode.js
var import_bbox_polygon6 = __toESM(require("@turf/bbox-polygon"), 1);
var DrawRectangleFromCenterMode = class extends TwoClickPolygonMode {
  getTwoClickPolygon(coord1, coord2, modeConfig) {
    const longitude = coord1[0] > coord2[0] ? coord1[0] + Math.abs(coord1[0] - coord2[0]) : coord1[0] - Math.abs(coord1[0] - coord2[0]);
    const latitude = coord1[1] > coord2[1] ? coord1[1] + Math.abs(coord1[1] - coord2[1]) : coord1[1] - Math.abs(coord1[1] - coord2[1]);
    const rectangle = (0, import_bbox_polygon6.default)([longitude, latitude, coord2[0], coord2[1]]);
    rectangle.properties = rectangle.properties || {};
    rectangle.properties.shape = "Rectangle";
    return rectangle;
  }
};

// dist/edit-modes/draw-square-from-center-mode.js
var import_bbox_polygon7 = __toESM(require("@turf/bbox-polygon"), 1);
var import_distance8 = __toESM(require("@turf/distance"), 1);
var import_along2 = __toESM(require("@turf/along"), 1);
var import_helpers11 = require("@turf/helpers");
var DrawSquareFromCenterMode = class extends TwoClickPolygonMode {
  getTwoClickPolygon(coord1, coord2, modeConfig) {
    const coord3 = [coord2[0], coord1[1]];
    const coord4 = [coord1[0], coord2[1]];
    const distance1 = (0, import_distance8.default)((0, import_helpers11.point)(coord3), (0, import_helpers11.point)(coord1));
    const distance22 = (0, import_distance8.default)((0, import_helpers11.point)(coord4), (0, import_helpers11.point)(coord1));
    const shortestDistance = distance1 <= distance22 ? distance1 : distance22;
    const closestPoint = distance1 <= distance22 ? coord3 : coord4;
    const line = (0, import_helpers11.lineString)([closestPoint, coord2]);
    const newPoint = (0, import_along2.default)(line, shortestDistance);
    const corner = newPoint.geometry.coordinates;
    const longitude = coord1[0] > corner[0] ? coord1[0] + Math.abs(coord1[0] - corner[0]) : coord1[0] - Math.abs(coord1[0] - corner[0]);
    const latitude = coord1[1] > corner[1] ? coord1[1] + Math.abs(coord1[1] - corner[1]) : coord1[1] - Math.abs(coord1[1] - corner[1]);
    const square = (0, import_bbox_polygon7.default)([longitude, latitude, corner[0], corner[1]]);
    square.properties = square.properties || {};
    square.properties.shape = "Square";
    return square;
  }
};

// dist/edit-modes/draw-circle-from-center-mode.js
var import_circle = __toESM(require("@turf/circle"), 1);
var import_distance9 = __toESM(require("@turf/distance"), 1);
var import_area = __toESM(require("@turf/area"), 1);
var DrawCircleFromCenterMode = class extends TwoClickPolygonMode {
  radius = null;
  position = null;
  areaCircle = null;
  getTwoClickPolygon(coord1, coord2, modeConfig) {
    const { steps = 64 } = modeConfig || {};
    const options = { steps };
    this.position = coord2;
    if (steps < 4) {
      console.warn("Minimum steps to draw a circle is 4 ");
      options.steps = 4;
    }
    this.radius = Math.max((0, import_distance9.default)(coord1, coord2), 1e-3);
    const geometry = (0, import_circle.default)(coord1, this.radius, options);
    geometry.properties = geometry.properties || {};
    geometry.properties.shape = "Circle";
    geometry.properties.editProperties = geometry.properties.editProperties || {};
    geometry.properties.editProperties.shape = "Circle";
    geometry.properties.editProperties.radius = { value: this.radius, unit: "kilometers" };
    geometry.properties.editProperties.center = coord1;
    this.areaCircle = (0, import_area.default)(geometry);
    return geometry;
  }
  /**
   * define the default function to display the tooltip for
   * nebula geometry mode type
   * @param props properties of geometry nebula mode
   */
  getTooltips(props) {
    return this._getTooltips({
      modeConfig: props == null ? void 0 : props.modeConfig,
      radius: this.radius,
      areaCircle: this.areaCircle
    });
  }
  /**
   * redefine the tooltip of geometry
   * @param modeConfig
   * @param radius
   * @param areaCircle
   */
  _getTooltips = memoize(({ modeConfig, radius, areaCircle }) => {
    let tooltips = [];
    const { formatTooltip } = modeConfig || {};
    let text;
    if (radius && areaCircle) {
      if (formatTooltip) {
        text = formatTooltip(radius);
      } else {
        text = `Radius: ${parseFloat(radius).toFixed(2)} kilometers
      
 Area: ${parseFloat(areaCircle).toFixed(2)}`;
      }
      tooltips = [
        {
          position: this.position,
          text
        }
      ];
    }
    return tooltips;
  });
};

// dist/edit-modes/draw-circle-by-diameter-mode.js
var import_circle2 = __toESM(require("@turf/circle"), 1);
var import_distance10 = __toESM(require("@turf/distance"), 1);
var import_area2 = __toESM(require("@turf/area"), 1);
var DrawCircleByDiameterMode = class extends TwoClickPolygonMode {
  radius = null;
  position = null;
  areaCircle = null;
  diameter = null;
  getTwoClickPolygon(coord1, coord2, modeConfig) {
    const { steps = 64 } = modeConfig || {};
    const options = { steps };
    if (steps < 4) {
      console.warn("Minimum steps to draw a circle is 4 ");
      options.steps = 4;
    }
    const centerCoordinates = getIntermediatePosition(coord1, coord2);
    this.radius = Math.max((0, import_distance10.default)(coord1, centerCoordinates), 1e-3);
    this.diameter = Math.max((0, import_distance10.default)(coord1, coord2), 1e-3);
    this.position = centerCoordinates;
    const geometry = (0, import_circle2.default)(centerCoordinates, this.radius, options);
    geometry.properties = geometry.properties || {};
    geometry.properties.shape = "Circle";
    geometry.properties.editProperties = geometry.properties.editProperties || {};
    geometry.properties.editProperties.shape = "Circle";
    geometry.properties.editProperties.radius = { value: this.radius, unit: "kilometers" };
    geometry.properties.editProperties.center = centerCoordinates;
    this.areaCircle = (0, import_area2.default)(geometry);
    return geometry;
  }
  /**
   * define the default function to display the tooltip for
   * nebula geometry mode type
   * @param props properties of geometry nebula mode
   */
  getTooltips(props) {
    return this._getTooltips({
      modeConfig: props.modeConfig,
      radius: this.radius,
      areaCircle: this.areaCircle,
      diameter: this.diameter
    });
  }
  /**
   * redefine the tooltip of geometry
   * @param modeConfig
   * @param radius
   * @param areaCircle
   * @param diameter
   */
  _getTooltips = memoize(({ modeConfig, radius, areaCircle, diameter }) => {
    let tooltips = [];
    const { formatTooltip } = modeConfig || {};
    let text;
    if (radius && areaCircle) {
      if (formatTooltip) {
        text = formatTooltip(radius);
      } else {
        text = `Radius: ${parseFloat(radius).toFixed(2)} kilometers
      
 Area: ${parseFloat(areaCircle).toFixed(2)}
      
 Diameter: ${parseFloat(diameter).toFixed(2)} kilometers`;
      }
      tooltips = [
        {
          position: this.position,
          text
        }
      ];
    }
    return tooltips;
  });
};

// dist/edit-modes/draw-ellipse-by-bounding-box-mode.js
var import_bbox_polygon8 = __toESM(require("@turf/bbox-polygon"), 1);
var import_distance11 = __toESM(require("@turf/distance"), 1);
var import_ellipse = __toESM(require("@turf/ellipse"), 1);
var import_helpers12 = require("@turf/helpers");
var DrawEllipseByBoundingBoxMode = class extends TwoClickPolygonMode {
  getTwoClickPolygon(coord1, coord2, modeConfig) {
    const minX = Math.min(coord1[0], coord2[0]);
    const minY = Math.min(coord1[1], coord2[1]);
    const maxX = Math.max(coord1[0], coord2[0]);
    const maxY = Math.max(coord1[1], coord2[1]);
    const polygonPoints = (0, import_bbox_polygon8.default)([minX, minY, maxX, maxY]).geometry.coordinates[0];
    const centerCoordinates = getIntermediatePosition(coord1, coord2);
    const xSemiAxis = Math.max((0, import_distance11.default)((0, import_helpers12.point)(polygonPoints[0]), (0, import_helpers12.point)(polygonPoints[1])), 1e-3);
    const ySemiAxis = Math.max((0, import_distance11.default)((0, import_helpers12.point)(polygonPoints[0]), (0, import_helpers12.point)(polygonPoints[3])), 1e-3);
    const geometry = (0, import_ellipse.default)(centerCoordinates, xSemiAxis, ySemiAxis);
    geometry.properties = geometry.properties || {};
    geometry.properties.editProperties = geometry.properties.editProperties || {};
    geometry.properties.editProperties.shape = "Ellipse";
    geometry.properties.editProperties.xSemiAxis = { value: xSemiAxis, unit: "kilometers" };
    geometry.properties.editProperties.ySemiAxis = { value: ySemiAxis, unit: "kilometers" };
    geometry.properties.editProperties.angle = 0;
    geometry.properties.editProperties.center = centerCoordinates;
    return geometry;
  }
};

// dist/edit-modes/three-click-polygon-mode.js
var import_lodash2 = __toESM(require("lodash.omit"), 1);
var ThreeClickPolygonMode = class extends GeoJsonEditMode {
  handleClick(event, props) {
    this.addClickSequence(event);
    const clickSequence = this.getClickSequence();
    const tentativeFeature = this.getTentativeGuide(props);
    if (clickSequence.length > 2 && tentativeFeature && tentativeFeature.geometry.type === "Polygon") {
      const editAction = this.getAddFeatureOrBooleanPolygonAction(tentativeFeature.geometry, props, (0, import_lodash2.default)(tentativeFeature.properties, "guideType"));
      this.resetClickSequence();
      if (editAction) {
        props.onEdit(editAction);
      }
    }
  }
  getGuides(props) {
    const { lastPointerMoveEvent, modeConfig } = props;
    const clickSequence = this.getClickSequence();
    const guides = {
      type: "FeatureCollection",
      features: []
    };
    if (clickSequence.length === 0) {
      return guides;
    }
    const hoveredCoord = lastPointerMoveEvent.mapCoords;
    if (clickSequence.length === 1) {
      guides.features.push({
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [clickSequence[0], hoveredCoord]
        }
      });
    } else {
      const polygon3 = this.getThreeClickPolygon(clickSequence[0], clickSequence[1], hoveredCoord, modeConfig);
      if (polygon3) {
        guides.features.push({
          type: "Feature",
          properties: {
            ...polygon3.properties,
            guideType: "tentative"
          },
          geometry: polygon3.geometry
        });
      }
    }
    return guides;
  }
  getThreeClickPolygon(coord1, coord2, coord3, modeConfig) {
    return null;
  }
  handlePointerMove(event, props) {
    props.onUpdateCursor("cell");
    super.handlePointerMove(event, props);
  }
  createTentativeFeature(props) {
    const { lastPointerMoveEvent } = props;
    const clickSequence = this.getClickSequence();
    const lastCoords = lastPointerMoveEvent ? [lastPointerMoveEvent.mapCoords] : [];
    let tentativeFeature;
    if (clickSequence.length === 2) {
      tentativeFeature = this.getThreeClickPolygon(clickSequence[0], clickSequence[1], lastCoords[0], props.modeConfig);
    }
    return tentativeFeature;
  }
};

// dist/edit-modes/draw-rectangle-using-three-points-mode.js
var DrawRectangleUsingThreePointsMode = class extends ThreeClickPolygonMode {
  getThreeClickPolygon(coord1, coord2, coord3, modeConfig) {
    const [p3, p4] = generatePointsParallelToLinePoints2(coord1, coord2, coord3);
    return {
      type: "Feature",
      properties: {
        shape: "Rectangle"
      },
      geometry: {
        type: "Polygon",
        coordinates: [
          [
            // Draw a polygon containing all the points of the LineString,
            // then the points orthogonal to the lineString,
            // then back to the starting position
            coord1,
            coord2,
            p3,
            p4,
            coord1
          ]
        ]
      }
    };
  }
};

// dist/edit-modes/draw-ellipse-using-three-points-mode.js
var import_distance12 = __toESM(require("@turf/distance"), 1);
var import_ellipse2 = __toESM(require("@turf/ellipse"), 1);
var import_bearing8 = __toESM(require("@turf/bearing"), 1);
var import_helpers13 = require("@turf/helpers");
var DrawEllipseUsingThreePointsMode = class extends ThreeClickPolygonMode {
  getThreeClickPolygon(coord1, coord2, coord3, modeConfig) {
    const centerCoordinates = getIntermediatePosition(coord1, coord2);
    const xSemiAxis = Math.max((0, import_distance12.default)(centerCoordinates, (0, import_helpers13.point)(coord3)), 1e-3);
    const ySemiAxis = Math.max((0, import_distance12.default)(coord1, coord2), 1e-3) / 2;
    const options = { angle: (0, import_bearing8.default)(coord1, coord2) };
    const geometry = (0, import_ellipse2.default)(centerCoordinates, xSemiAxis, ySemiAxis, options);
    geometry.properties = geometry.properties || {};
    geometry.properties.editProperties = geometry.properties.editProperties || {};
    geometry.properties.editProperties.shape = "Ellipse";
    geometry.properties.editProperties.xSemiAxis = { value: xSemiAxis, unit: "kilometers" };
    geometry.properties.editProperties.ySemiAxis = { value: ySemiAxis, unit: "kilometers" };
    geometry.properties.editProperties.angle = options.angle;
    geometry.properties.editProperties.center = centerCoordinates;
    return geometry;
  }
};

// dist/edit-modes/draw-90degree-polygon-mode.js
var import_destination4 = __toESM(require("@turf/destination"), 1);
var import_bearing9 = __toESM(require("@turf/bearing"), 1);
var import_line_intersect3 = __toESM(require("@turf/line-intersect"), 1);
var import_distance13 = __toESM(require("@turf/distance"), 1);
var import_helpers14 = require("@turf/helpers");
var Draw90DegreePolygonMode = class extends GeoJsonEditMode {
  createTentativeFeature(props) {
    const clickSequence = this.getClickSequence();
    const { mapCoords: mapCoords2 } = props.lastPointerMoveEvent;
    let p3;
    if (clickSequence.length <= 1) {
      p3 = mapCoords2;
    } else {
      const p1 = clickSequence[clickSequence.length - 2];
      const p2 = clickSequence[clickSequence.length - 1];
      [p3] = generatePointsParallelToLinePoints2(p1, p2, mapCoords2);
    }
    let tentativeFeature;
    if (clickSequence.length < 3) {
      tentativeFeature = {
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [...clickSequence, p3]
        }
      };
    } else {
      tentativeFeature = {
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "Polygon",
          coordinates: [[...clickSequence, p3, clickSequence[0]]]
        }
      };
    }
    return tentativeFeature;
  }
  getGuides(props) {
    const guides = {
      type: "FeatureCollection",
      features: []
    };
    const clickSequence = this.getClickSequence();
    if (clickSequence.length === 0 || !props.lastPointerMoveEvent) {
      return guides;
    }
    const tentativeFeature = this.createTentativeFeature(props);
    guides.features.push(tentativeFeature);
    guides.features = guides.features.concat(getEditHandlesForGeometry(tentativeFeature.geometry, -1));
    guides.features = guides.features.slice(0, -1);
    return guides;
  }
  handlePointerMove(event, props) {
    props.onUpdateCursor("cell");
    super.handlePointerMove(event, props);
  }
  handleClick(event, props) {
    const { picks } = event;
    const tentativeFeature = this.getTentativeGuide(props);
    this.addClickSequence(event);
    const clickSequence = this.getClickSequence();
    if (!tentativeFeature) {
      return;
    }
    if (clickSequence.length === 3 && tentativeFeature.geometry.type === "LineString") {
      const lineString3 = tentativeFeature.geometry;
      clickSequence[clickSequence.length - 1] = lineString3.coordinates[lineString3.coordinates.length - 1];
    } else if (clickSequence.length > 3 && tentativeFeature.geometry.type === "Polygon") {
      const polygon3 = tentativeFeature.geometry;
      clickSequence[clickSequence.length - 1] = polygon3.coordinates[0][polygon3.coordinates[0].length - 2];
      const clickedEditHandle = getPickedEditHandle(picks);
      if (clickedEditHandle && Array.isArray(clickedEditHandle.properties.positionIndexes) && (clickedEditHandle.properties.positionIndexes[1] === 0 || clickedEditHandle.properties.positionIndexes[1] === polygon3.coordinates[0].length - 3)) {
        const polygonToAdd = {
          type: "Polygon",
          coordinates: this.finalizedCoordinates([...polygon3.coordinates[0]])
        };
        this.resetClickSequence();
        const editAction = this.getAddFeatureOrBooleanPolygonAction(polygonToAdd, props);
        if (editAction) {
          props.onEdit(editAction);
        }
      }
    } else {
      const fakePointerMoveEvent = {
        screenCoords: [-1, -1],
        mapCoords: event.mapCoords,
        picks: [],
        pointerDownPicks: null,
        pointerDownScreenCoords: null,
        pointerDownMapCoords: null,
        cancelPan: () => {
        },
        sourceEvent: null
      };
      this.handlePointerMove(fakePointerMoveEvent, props);
    }
  }
  finalizedCoordinates(coords) {
    let coordinates = [[...coords.slice(0, -2), coords[0]]];
    let pt = this.getIntermediatePoint([...coords]);
    if (!pt) {
      const tc = [...coords];
      tc.splice(-3, 1);
      pt = this.getIntermediatePoint([...tc]);
      if (pt) {
        coordinates = [[...coords.slice(0, -3), pt, coords[0]]];
      }
    } else {
      coordinates = [[...coords.slice(0, -2), pt, coords[0]]];
    }
    return coordinates;
  }
  getIntermediatePoint(coordinates) {
    let pt = null;
    if (coordinates.length > 4) {
      const [p1, p2] = [...coordinates];
      const angle1 = (0, import_bearing9.default)(p1, p2);
      const p3 = coordinates[coordinates.length - 3];
      const p4 = coordinates[coordinates.length - 4];
      const angle2 = (0, import_bearing9.default)(p3, p4);
      const angles = { first: [], second: [] };
      [1, 2, 3].forEach((factor) => {
        const newAngle1 = angle1 + factor * 90;
        angles.first.push(newAngle1 > 180 ? newAngle1 - 360 : newAngle1);
        const newAngle2 = angle2 + factor * 90;
        angles.second.push(newAngle2 > 180 ? newAngle2 - 360 : newAngle2);
      });
      const distance7 = (0, import_distance13.default)((0, import_helpers14.point)(p1), (0, import_helpers14.point)(p3));
      [0, 1, 2].forEach((indexFirst) => {
        const line1 = (0, import_helpers14.lineString)([
          p1,
          (0, import_destination4.default)(p1, distance7, angles.first[indexFirst]).geometry.coordinates
        ]);
        [0, 1, 2].forEach((indexSecond) => {
          const line2 = (0, import_helpers14.lineString)([
            p3,
            (0, import_destination4.default)(p3, distance7, angles.second[indexSecond]).geometry.coordinates
          ]);
          const fc = (0, import_line_intersect3.default)(line1, line2);
          if (fc && fc.features.length) {
            pt = fc.features[0].geometry.coordinates;
          }
        });
      });
    }
    return pt;
  }
};

// dist/edit-modes/draw-polygon-by-dragging-mode.js
var import_lodash3 = __toESM(require("lodash.throttle"), 1);
var DrawPolygonByDraggingMode = class extends DrawPolygonMode {
  handleDraggingThrottled = null;
  handleClick(event, props) {
  }
  handleStartDragging(event, props) {
    event.cancelPan();
    if (props.modeConfig && props.modeConfig.throttleMs) {
      this.handleDraggingThrottled = (0, import_lodash3.default)(this.handleDraggingAux, props.modeConfig.throttleMs);
    } else {
      this.handleDraggingThrottled = this.handleDraggingAux;
    }
  }
  handleStopDragging(event, props) {
    this.addClickSequence(event);
    const clickSequence = this.getClickSequence();
    if (this.handleDraggingThrottled && this.handleDraggingThrottled.cancel) {
      this.handleDraggingThrottled.cancel();
    }
    if (clickSequence.length > 2) {
      const polygonToAdd = {
        type: "Polygon",
        coordinates: [[...clickSequence, clickSequence[0]]]
      };
      const editAction = this.getAddFeatureOrBooleanPolygonAction(polygonToAdd, props);
      if (editAction) {
        props.onEdit(editAction);
      }
    }
    this.resetClickSequence();
  }
  handleDraggingAux(event, props) {
    const { picks } = event;
    const clickedEditHandle = getPickedEditHandle(picks);
    if (!clickedEditHandle) {
      this.addClickSequence(event);
      props.onEdit({
        updatedData: props.data,
        editType: "addTentativePosition",
        editContext: {
          position: event.mapCoords
        }
      });
    }
  }
  handleDragging(event, props) {
    if (this.handleDraggingThrottled) {
      this.handleDraggingThrottled(event, props);
    }
  }
  handleKeyUp(event, props) {
    if (event.key === "Enter") {
      const clickSequence = this.getClickSequence();
      if (clickSequence.length > 2) {
        const polygonToAdd = {
          type: "Polygon",
          coordinates: [[...clickSequence, clickSequence[0]]]
        };
        this.resetClickSequence();
        const editAction = this.getAddFeatureOrBooleanPolygonAction(polygonToAdd, props);
        if (editAction) {
          props.onEdit(editAction);
        }
      }
    } else if (event.key === "Escape") {
      this.resetClickSequence();
      if (this.handleDraggingThrottled) {
        this.handleDraggingThrottled = null;
      }
      props.onEdit({
        // Because the new drawing feature is dropped, so the data will keep as the same.
        updatedData: props.data,
        editType: "cancelFeature",
        editContext: {}
      });
    }
  }
};

// dist/edit-modes/snappable-mode.js
var SnappableMode = class extends GeoJsonEditMode {
  _handler;
  constructor(handler) {
    super();
    this._handler = handler;
  }
  _getSnappedMouseEvent(event, snapSource, snapTarget) {
    return Object.assign(event, {
      mapCoords: snapTarget.geometry.coordinates,
      pointerDownMapCoords: snapSource && snapSource.geometry.coordinates
    });
  }
  _getPickedSnapTarget(picks) {
    return getPickedEditHandles(picks).find((handle) => handle.properties.editHandleType === "snap-target");
  }
  _getPickedSnapSource(pointerDownPicks) {
    return getPickedSnapSourceEditHandle(pointerDownPicks);
  }
  _getUpdatedSnapSourceHandle(snapSourceHandle, data) {
    const { featureIndex, positionIndexes } = snapSourceHandle.properties;
    if (!Array.isArray(positionIndexes)) {
      return snapSourceHandle;
    }
    const snapSourceFeature = data.features[featureIndex];
    const snapSourceCoordinates = positionIndexes.reduce((a, b) => a[b], snapSourceFeature.geometry.coordinates);
    return {
      ...snapSourceHandle,
      geometry: {
        type: "Point",
        coordinates: snapSourceCoordinates
      }
    };
  }
  // If additionalSnapTargets is present in modeConfig and is populated, this
  // method will return those features along with the features
  // that live in the current layer. Otherwise, this method will simply return the
  // features from the current layer
  _getSnapTargets(props) {
    let { additionalSnapTargets } = props.modeConfig || {};
    additionalSnapTargets = additionalSnapTargets || [];
    const features = [...props.data.features, ...additionalSnapTargets];
    return features;
  }
  _getSnapTargetHandles(props) {
    const handles = [];
    const features = this._getSnapTargets(props);
    for (let i = 0; i < features.length; i++) {
      const isCurrentIndexFeatureNotSelected = !props.selectedIndexes.includes(i);
      if (isCurrentIndexFeatureNotSelected) {
        const { geometry } = features[i];
        handles.push(...getEditHandlesForGeometry(geometry, i, "snap-target"));
      }
    }
    return handles;
  }
  // If no snap handle has been picked, only display the edit handles of the
  // selected feature. If a snap handle has been picked, display said snap handle
  // along with all snappable points on all non-selected features.
  getGuides(props) {
    const { modeConfig, lastPointerMoveEvent } = props;
    const { enableSnapping } = modeConfig || {};
    const guides = {
      type: "FeatureCollection",
      features: [...this._handler.getGuides(props).features]
    };
    if (!enableSnapping) {
      return guides;
    }
    const snapSourceHandle = lastPointerMoveEvent && this._getPickedSnapSource(lastPointerMoveEvent.pointerDownPicks);
    if (snapSourceHandle) {
      guides.features.push(...this._getSnapTargetHandles(props), this._getUpdatedSnapSourceHandle(snapSourceHandle, props.data));
      return guides;
    }
    const { features } = props.data;
    for (const index of props.selectedIndexes) {
      if (index < features.length) {
        const { geometry } = features[index];
        guides.features.push(...getEditHandlesForGeometry(geometry, index, "snap-source"));
      }
    }
    return guides;
  }
  _getSnapAwareEvent(event, props) {
    const snapSource = this._getPickedSnapSource(props.lastPointerMoveEvent.pointerDownPicks);
    const snapTarget = this._getPickedSnapTarget(event.picks);
    return snapSource && snapTarget ? this._getSnappedMouseEvent(event, snapSource, snapTarget) : event;
  }
  handleStartDragging(event, props) {
    this._handler.handleStartDragging(event, props);
  }
  handleStopDragging(event, props) {
    this._handler.handleStopDragging(this._getSnapAwareEvent(event, props), props);
  }
  handleDragging(event, props) {
    this._handler.handleDragging(this._getSnapAwareEvent(event, props), props);
  }
  handlePointerMove(event, props) {
    this._handler.handlePointerMove(this._getSnapAwareEvent(event, props), props);
  }
};

// dist/edit-modes/transform-mode.js
var import_helpers15 = require("@turf/helpers");

// dist/edit-modes/composite-mode.js
var CompositeMode = class extends GeoJsonEditMode {
  _modes;
  constructor(modes) {
    super();
    this._modes = modes;
  }
  _coalesce(callback, resultEval = null) {
    let result = null;
    for (let i = 0; i < this._modes.length; i++) {
      result = callback(this._modes[i]);
      if (resultEval ? resultEval(result) : result) {
        break;
      }
    }
    return result;
  }
  handleClick(event, props) {
    this._coalesce((handler) => handler.handleClick(event, props));
  }
  handlePointerMove(event, props) {
    return this._coalesce((handler) => handler.handlePointerMove(event, props));
  }
  handleStartDragging(event, props) {
    return this._coalesce((handler) => handler.handleStartDragging(event, props));
  }
  handleStopDragging(event, props) {
    return this._coalesce((handler) => handler.handleStopDragging(event, props));
  }
  handleDragging(event, props) {
    return this._coalesce((handler) => handler.handleDragging(event, props));
  }
  getGuides(props) {
    const allGuides = [];
    for (const mode of this._modes) {
      allGuides.push(...mode.getGuides(props).features);
    }
    return {
      type: "FeatureCollection",
      features: allGuides
    };
  }
};

// dist/edit-modes/transform-mode.js
var TransformMode = class extends CompositeMode {
  constructor() {
    super([new TranslateMode(), new ScaleMode(), new RotateMode()]);
  }
  handlePointerMove(event, props) {
    let updatedCursor = null;
    super.handlePointerMove(event, {
      ...props,
      onUpdateCursor: (cursor) => {
        updatedCursor = cursor || updatedCursor;
      }
    });
    props.onUpdateCursor(updatedCursor);
  }
  handleStartDragging(event, props) {
    let scaleMode = null;
    let translateMode = null;
    const filteredModes = [];
    if (event.picks.length) {
      event.cancelPan();
    }
    this._modes.forEach((mode) => {
      if (mode instanceof TranslateMode) {
        translateMode = mode;
      } else {
        if (mode instanceof ScaleMode) {
          scaleMode = mode;
        }
        filteredModes.push(mode);
      }
    });
    if (scaleMode instanceof ScaleMode && !scaleMode.isEditHandleSelected()) {
      filteredModes.push(translateMode);
    }
    filteredModes.filter(Boolean).forEach((mode) => mode.handleStartDragging(event, props));
  }
  getGuides(props) {
    let compositeGuides = super.getGuides(props);
    const rotateMode = (this._modes || []).find((mode) => mode instanceof RotateMode);
    if (rotateMode instanceof RotateMode) {
      const nonEnvelopeGuides = compositeGuides.features.filter((guide) => {
        const { editHandleType, mode } = guide.properties || {};
        const guidesToFilterOut = [mode];
        if (rotateMode.getIsRotating()) {
          guidesToFilterOut.push(editHandleType);
        }
        return !guidesToFilterOut.includes("scale");
      });
      compositeGuides = (0, import_helpers15.featureCollection)(nonEnvelopeGuides);
    }
    return compositeGuides;
  }
};

// dist/edit-modes/delete-mode.js
var DeleteMode = class extends GeoJsonEditMode {
  handleClick(_event, props) {
    const selectedFeatureIndexes = props.lastPointerMoveEvent.picks.map((pick) => pick.index);
    if (selectedFeatureIndexes.length > 0) {
      const indexToDelete = selectedFeatureIndexes[0];
      const features = props.data.features.filter((_, index) => index !== indexToDelete);
      const updatedData = {
        ...props.data,
        features
      };
      const editAction = {
        updatedData,
        editType: "deleteFeature",
        editContext: {
          featureIndexes: selectedFeatureIndexes
        }
      };
      props.onEdit(editAction);
    }
  }
};

// dist/constants.js
var PROJECTED_PIXEL_SIZE_MULTIPLIER2 = 2 / 3;

// dist/editable-layers/editable-layer.js
var import_core3 = require("@deck.gl/core");
var EVENT_TYPES = ["click", "pointermove", "panstart", "panmove", "panend", "keyup"];
var EditableLayer = class extends import_core3.CompositeLayer {
  state = void 0;
  // Overridable interaction event handlers
  onLayerClick(event) {
  }
  onStartDragging(event) {
  }
  onStopDragging(event) {
  }
  onDragging(event) {
  }
  onPointerMove(event) {
  }
  onLayerKeyUp(event) {
  }
  // TODO: implement onCancelDragging (e.g. drag off screen)
  initializeState() {
    this.setState({
      _editableLayerState: {
        // Picked objects at the time the pointer went down
        pointerDownPicks: null,
        // Screen coordinates where the pointer went down
        pointerDownScreenCoords: null,
        // Ground coordinates where the pointer went down
        pointerDownMapCoords: null,
        // Keep track of the mjolnir.js event handler so it can be deregistered
        eventHandler: this._forwardEventToCurrentLayer.bind(this)
      }
    });
    this._addEventHandlers();
  }
  finalizeState() {
    this._removeEventHandlers();
  }
  _addEventHandlers() {
    const { eventManager } = this.context.deck;
    const { eventHandler } = this.state._editableLayerState;
    for (const eventType of EVENT_TYPES) {
      eventManager.on(eventType, eventHandler, {
        // give nebula a higher priority so that it can stop propagation to deck.gl's map panning handlers
        priority: 100
      });
    }
  }
  _removeEventHandlers() {
    const { eventManager } = this.context.deck;
    const { eventHandler } = this.state._editableLayerState;
    for (const eventType of EVENT_TYPES) {
      eventManager.off(eventType, eventHandler);
    }
  }
  // A new layer instance is created on every render, so forward the event to the current layer
  // This means that the first layer instance will stick around to be the event listener, but will forward the event
  // to the latest layer instance.
  _forwardEventToCurrentLayer(event) {
    const currentLayer = this.getCurrentLayer();
    const func = currentLayer[`_on${event.type}`].bind(currentLayer);
    if (!func) {
      console.warn(`no handler for mjolnir.js event ${event.type}`);
      return;
    }
    func(event);
  }
  _onclick({ srcEvent }) {
    const screenCoords = this.getScreenCoords(srcEvent);
    const mapCoords2 = this.getMapCoords(screenCoords);
    const picks = this.getPicks(screenCoords);
    this.onLayerClick({
      mapCoords: mapCoords2,
      screenCoords,
      picks,
      sourceEvent: srcEvent
    });
  }
  _onkeyup({ srcEvent }) {
    this.onLayerKeyUp(srcEvent);
  }
  _onpanstart(event) {
    const screenCoords = this.getScreenCoords(event.srcEvent);
    const mapCoords2 = this.getMapCoords(screenCoords);
    const picks = this.getPicks(screenCoords);
    this.setState({
      _editableLayerState: {
        ...this.state._editableLayerState,
        pointerDownScreenCoords: screenCoords,
        pointerDownMapCoords: mapCoords2,
        pointerDownPicks: picks
      }
    });
    this.onStartDragging({
      picks,
      screenCoords,
      mapCoords: mapCoords2,
      pointerDownScreenCoords: screenCoords,
      pointerDownMapCoords: mapCoords2,
      cancelPan: () => {
        if (this.props.onCancelPan) {
          this.props.onCancelPan();
        }
        event.stopImmediatePropagation();
      },
      sourceEvent: event.srcEvent
    });
  }
  _onpanmove(event) {
    const { srcEvent } = event;
    const screenCoords = this.getScreenCoords(srcEvent);
    const mapCoords2 = this.getMapCoords(screenCoords);
    const { pointerDownPicks, pointerDownScreenCoords, pointerDownMapCoords } = this.state._editableLayerState;
    const picks = this.getPicks(screenCoords);
    this.onDragging({
      screenCoords,
      mapCoords: mapCoords2,
      picks,
      pointerDownPicks,
      pointerDownScreenCoords,
      pointerDownMapCoords,
      sourceEvent: srcEvent,
      cancelPan: event.stopImmediatePropagation
      // another (hacky) approach for cancelling map panning
      // const controller = this.context.deck.viewManager.controllers[
      //   Object.keys(this.context.deck.viewManager.controllers)[0]
      // ];
      // controller._state.isDragging = false;
    });
  }
  _onpanend({ srcEvent }) {
    const screenCoords = this.getScreenCoords(srcEvent);
    const mapCoords2 = this.getMapCoords(screenCoords);
    const { pointerDownPicks, pointerDownScreenCoords, pointerDownMapCoords } = this.state._editableLayerState;
    const picks = this.getPicks(screenCoords);
    this.onStopDragging({
      picks,
      screenCoords,
      mapCoords: mapCoords2,
      pointerDownPicks,
      pointerDownScreenCoords,
      pointerDownMapCoords,
      sourceEvent: srcEvent
    });
    this.setState({
      _editableLayerState: {
        ...this.state._editableLayerState,
        pointerDownScreenCoords: null,
        pointerDownMapCoords: null,
        pointerDownPicks: null
      }
    });
  }
  _onpointermove(event) {
    const { srcEvent } = event;
    const screenCoords = this.getScreenCoords(srcEvent);
    const mapCoords2 = this.getMapCoords(screenCoords);
    const { pointerDownPicks, pointerDownScreenCoords, pointerDownMapCoords } = this.state._editableLayerState;
    const picks = this.getPicks(screenCoords);
    this.onPointerMove({
      screenCoords,
      mapCoords: mapCoords2,
      picks,
      pointerDownPicks,
      pointerDownScreenCoords,
      pointerDownMapCoords,
      sourceEvent: srcEvent,
      cancelPan: event.stopImmediatePropagation
    });
  }
  getPicks(screenCoords) {
    return this.context.deck.pickMultipleObjects({
      x: screenCoords[0],
      y: screenCoords[1],
      layerIds: [this.props.id],
      radius: this.props.pickingRadius,
      depth: this.props.pickingDepth
    });
  }
  getScreenCoords(pointerEvent) {
    return [
      pointerEvent.clientX - this.context.gl.canvas.getBoundingClientRect().left,
      pointerEvent.clientY - this.context.gl.canvas.getBoundingClientRect().top
    ];
  }
  getMapCoords(screenCoords) {
    return this.context.viewport.unproject([screenCoords[0], screenCoords[1]]);
  }
};
__publicField(EditableLayer, "layerName", "EditableLayer");

// dist/editable-layers/editable-path-layer.js
var import_layers5 = require("@deck.gl/layers");
var uniformBlock = `uniform pickingLineWidthUniforms {
  float extraPixels;
} pickingLineWidth;
`;
var pickingUniforms = {
  name: "pickingLineWidth",
  vs: uniformBlock,
  fs: uniformBlock,
  uniformTypes: {
    extraPixels: "f32"
  }
};
var defaultProps = {
  ...import_layers5.PathLayer.defaultProps,
  pickingLineWidthExtraPixels: { type: "number", min: 0, value: Number.MAX_SAFE_INTEGER }
};
var EditablePathLayer = class extends import_layers5.PathLayer {
  getShaders() {
    const shaders = super.getShaders();
    shaders.vs = insertBefore(shaders.vs, "vec3 width;", `
       if(bool(picking.isActive)){
        widthPixels.xy += pickingLineWidth.extraPixels;
       }
      `);
    return {
      ...shaders,
      modules: [...shaders.modules, pickingUniforms]
    };
  }
  draw(props) {
    const { pickingLineWidthExtraPixels } = this.props;
    const pickingProps = { extraPixels: pickingLineWidthExtraPixels };
    const model = this.state.model;
    model.shaderInputs.setProps({ pickingLineWidth: pickingProps });
    super.draw(props);
  }
};
EditablePathLayer.defaultProps = defaultProps;
EditablePathLayer.layerName = "EditablePathLayer";

// dist/editable-layers/editable-geojson-layer.js
var DEFAULT_LINE_COLOR = [0, 0, 0, 153];
var DEFAULT_FILL_COLOR = [0, 0, 0, 144];
var DEFAULT_SELECTED_LINE_COLOR = [0, 0, 0, 255];
var DEFAULT_SELECTED_FILL_COLOR = [0, 0, 144, 144];
var DEFAULT_TENTATIVE_LINE_COLOR = [144, 144, 144, 255];
var DEFAULT_TENTATIVE_FILL_COLOR = [144, 144, 144, 144];
var DEFAULT_EDITING_EXISTING_POINT_COLOR = [192, 0, 0, 255];
var DEFAULT_EDITING_INTERMEDIATE_POINT_COLOR = [0, 0, 0, 128];
var DEFAULT_EDITING_SNAP_POINT_COLOR = [124, 0, 192, 255];
var DEFAULT_EDITING_POINT_OUTLINE_COLOR = [255, 255, 255, 255];
var DEFAULT_EDITING_EXISTING_POINT_RADIUS = 5;
var DEFAULT_EDITING_INTERMEDIATE_POINT_RADIUS = 3;
var DEFAULT_EDITING_SNAP_POINT_RADIUS = 7;
var DEFAULT_TOOLTIP_FONT_SIZE = 32 * PROJECTED_PIXEL_SIZE_MULTIPLIER2;
var DEFAULT_EDIT_MODE = DrawPolygonMode;
function guideAccessor(accessor) {
  if (!accessor || typeof accessor !== "function") {
    return accessor;
  }
  return (guideMaybeWrapped) => accessor(unwrapGuide(guideMaybeWrapped));
}
function unwrapGuide(guideMaybeWrapped) {
  if (guideMaybeWrapped.__source) {
    return guideMaybeWrapped.__source.object;
  } else if (guideMaybeWrapped.sourceFeature) {
    return guideMaybeWrapped.sourceFeature.feature;
  }
  return guideMaybeWrapped;
}
function getEditHandleColor(handle) {
  switch (handle.properties.editHandleType) {
    case "existing":
      return DEFAULT_EDITING_EXISTING_POINT_COLOR;
    case "snap-source":
      return DEFAULT_EDITING_SNAP_POINT_COLOR;
    case "intermediate":
    default:
      return DEFAULT_EDITING_INTERMEDIATE_POINT_COLOR;
  }
}
function getEditHandleOutlineColor(handle) {
  return DEFAULT_EDITING_POINT_OUTLINE_COLOR;
}
function getEditHandleRadius(handle) {
  switch (handle.properties.editHandleType) {
    case "existing":
      return DEFAULT_EDITING_EXISTING_POINT_RADIUS;
    case "snap":
      return DEFAULT_EDITING_SNAP_POINT_RADIUS;
    case "intermediate":
    default:
      return DEFAULT_EDITING_INTERMEDIATE_POINT_RADIUS;
  }
}
var defaultProps2 = {
  mode: DEFAULT_EDIT_MODE,
  // Edit and interaction events
  onEdit: () => {
  },
  pickable: true,
  pickingRadius: 10,
  pickingDepth: 5,
  fp64: false,
  filled: true,
  stroked: true,
  lineWidthScale: PROJECTED_PIXEL_SIZE_MULTIPLIER2,
  lineWidthMinPixels: 1,
  lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
  pickingLineWidthExtraPixels: 0,
  lineWidthUnits: "pixels",
  lineJointRounded: false,
  lineCapRounded: false,
  lineMiterLimit: 4,
  pointRadiusScale: 1,
  pointRadiusMinPixels: 2,
  pointRadiusMaxPixels: Number.MAX_SAFE_INTEGER,
  getLineColor: (feature, isSelected, mode) => isSelected ? DEFAULT_SELECTED_LINE_COLOR : DEFAULT_LINE_COLOR,
  getFillColor: (feature, isSelected, mode) => isSelected ? DEFAULT_SELECTED_FILL_COLOR : DEFAULT_FILL_COLOR,
  getRadius: (f) => f && f.properties && f.properties.radius || f && f.properties && f.properties.size || 1,
  getLineWidth: (f) => f && f.properties && f.properties.lineWidth || 3,
  // Tentative feature rendering
  getTentativeLineColor: (f) => DEFAULT_TENTATIVE_LINE_COLOR,
  getTentativeFillColor: (f) => DEFAULT_TENTATIVE_FILL_COLOR,
  getTentativeLineWidth: (f) => f && f.properties && f.properties.lineWidth || 3,
  editHandleType: "point",
  // point handles
  editHandlePointRadiusScale: 1,
  editHandlePointOutline: true,
  editHandlePointStrokeWidth: 2,
  editHandlePointRadiusUnits: "pixels",
  editHandlePointRadiusMinPixels: 4,
  editHandlePointRadiusMaxPixels: 8,
  getEditHandlePointColor: getEditHandleColor,
  getEditHandlePointOutlineColor: getEditHandleOutlineColor,
  getEditHandlePointRadius: getEditHandleRadius,
  // icon handles
  editHandleIconAtlas: null,
  editHandleIconMapping: null,
  editHandleIconSizeScale: 1,
  editHandleIconSizeUnits: "pixels",
  getEditHandleIcon: (handle) => handle.properties.editHandleType,
  getEditHandleIconSize: 10,
  getEditHandleIconColor: getEditHandleColor,
  getEditHandleIconAngle: 0,
  // misc
  billboard: true
};
var modeNameMapping = {
  view: ViewMode,
  // Alter modes
  modify: ModifyMode,
  translate: new SnappableMode(new TranslateMode()),
  transform: new SnappableMode(new TransformMode()),
  scale: ScaleMode,
  rotate: RotateMode,
  duplicate: DuplicateMode,
  split: SplitPolygonMode,
  extrude: ExtrudeMode,
  elevation: ElevationMode,
  delete: DeleteMode,
  // Draw modes
  drawPoint: DrawPointMode,
  drawLineString: DrawLineStringMode,
  drawPolygon: DrawPolygonMode,
  drawRectangle: DrawRectangleMode,
  drawSquare: DrawSquareMode,
  drawRectangleFromCenter: DrawRectangleFromCenterMode,
  drawSquareFromCenter: DrawSquareFromCenterMode,
  drawCircleFromCenter: DrawCircleFromCenterMode,
  drawCircleByBoundingBox: DrawCircleByDiameterMode,
  drawEllipseByBoundingBox: DrawEllipseByBoundingBoxMode,
  drawRectangleUsing3Points: DrawRectangleUsingThreePointsMode,
  drawEllipseUsing3Points: DrawEllipseUsingThreePointsMode,
  draw90DegreePolygon: Draw90DegreePolygonMode,
  drawPolygonByDragging: DrawPolygonByDraggingMode
};
var EditableGeoJsonLayer = class extends EditableLayer {
  state = void 0;
  // setState: ($Shape<State>) => void;
  renderLayers() {
    const subLayerProps = this.getSubLayerProps({
      id: "geojson",
      // Proxy most GeoJsonLayer props as-is
      data: this.props.data,
      fp64: this.props.fp64,
      filled: this.props.filled,
      stroked: this.props.stroked,
      lineWidthScale: this.props.lineWidthScale,
      lineWidthMinPixels: this.props.lineWidthMinPixels,
      lineWidthMaxPixels: this.props.lineWidthMaxPixels,
      lineWidthUnits: this.props.lineWidthUnits,
      lineJointRounded: this.props.lineJointRounded,
      lineCapRounded: this.props.lineCapRounded,
      lineMiterLimit: this.props.lineMiterLimit,
      pointRadiusScale: this.props.pointRadiusScale,
      pointRadiusMinPixels: this.props.pointRadiusMinPixels,
      pointRadiusMaxPixels: this.props.pointRadiusMaxPixels,
      getLineColor: this.selectionAwareAccessor(this.props.getLineColor),
      getFillColor: this.selectionAwareAccessor(this.props.getFillColor),
      getPointRadius: this.selectionAwareAccessor(this.props.getRadius),
      getLineWidth: this.selectionAwareAccessor(this.props.getLineWidth),
      _subLayerProps: {
        linestrings: {
          billboard: this.props.billboard,
          updateTriggers: {
            // required to update dashed array attribute
            all: [this.props.selectedFeatureIndexes, this.props.mode]
          }
        },
        "polygons-stroke": {
          billboard: this.props.billboard,
          pickingLineWidthExtraPixels: this.props.pickingLineWidthExtraPixels,
          type: EditablePathLayer,
          updateTriggers: {
            // required to update dashed array attribute
            all: [this.props.selectedFeatureIndexes, this.props.mode]
          }
        }
      },
      updateTriggers: {
        getLineColor: [this.props.selectedFeatureIndexes, this.props.mode],
        getFillColor: [this.props.selectedFeatureIndexes, this.props.mode],
        getPointRadius: [this.props.selectedFeatureIndexes, this.props.mode],
        getLineWidth: [this.props.selectedFeatureIndexes, this.props.mode]
      }
    });
    let layers = [new import_layers6.GeoJsonLayer(subLayerProps)];
    layers = layers.concat(this.createGuidesLayers(), this.createTooltipsLayers());
    return layers;
  }
  initializeState() {
    super.initializeState();
    this.setState({
      selectedFeatures: [],
      editHandles: []
    });
  }
  // TODO: is this the best way to properly update state from an outside event handler?
  shouldUpdateState(opts) {
    return super.shouldUpdateState(opts) || opts.changeFlags.stateChanged;
  }
  updateState({ props, oldProps, changeFlags, context }) {
    super.updateState({ oldProps, props, changeFlags, context });
    if (changeFlags.propsOrDataChanged) {
      const modePropChanged = Object.keys(oldProps).length === 0 || props.mode !== oldProps.mode;
      if (modePropChanged) {
        let mode;
        if (typeof props.mode === "function") {
          const ModeConstructor = props.mode;
          mode = new ModeConstructor();
        } else if (typeof props.mode === "string") {
          mode = modeNameMapping[props.mode];
          console.warn("Deprecated use of passing `mode` as a string. Pass the mode's class constructor instead.");
        } else {
          mode = props.mode;
        }
        if (!mode) {
          console.warn(`No mode configured for ${String(props.mode)}`);
          mode = new DEFAULT_EDIT_MODE();
        }
        if (mode !== this.state.mode) {
          this.setState({ mode, cursor: null });
        }
      }
    }
    let selectedFeatures = [];
    if (Array.isArray(props.selectedFeatureIndexes) && typeof props.data === "object" && "features" in props.data) {
      const propsData = props.data;
      selectedFeatures = props.selectedFeatureIndexes.map((elem) => propsData.features[elem]);
    }
    this.setState({ selectedFeatures });
  }
  getModeProps(props) {
    return {
      modeConfig: props.modeConfig,
      data: props.data,
      selectedIndexes: props.selectedFeatureIndexes,
      lastPointerMoveEvent: this.state.lastPointerMoveEvent,
      cursor: this.state.cursor,
      onEdit: (editAction) => {
        this.setNeedsUpdate();
        props.onEdit(editAction);
      },
      onUpdateCursor: (cursor) => {
        this.setState({ cursor });
      }
    };
  }
  selectionAwareAccessor(accessor) {
    if (typeof accessor !== "function") {
      return accessor;
    }
    return (feature) => accessor(feature, this.isFeatureSelected(feature), this.props.mode);
  }
  isFeatureSelected(feature) {
    if (!this.props.data || !this.props.selectedFeatureIndexes) {
      return false;
    }
    if (!this.props.selectedFeatureIndexes.length) {
      return false;
    }
    return this.state.selectedFeatures.includes(feature);
  }
  getPickingInfo({ info, sourceLayer }) {
    if (sourceLayer.id.endsWith("guides")) {
      info.isGuide = true;
    }
    return info;
  }
  _updateAutoHighlight(info) {
    if (info == null ? void 0 : info.sourceLayer) {
      if (info.isGuide) {
        for (const layer of info.sourceLayer.getSubLayers()) {
          layer.updateAutoHighlight(info);
        }
      } else {
        info.sourceLayer.updateAutoHighlight(info);
      }
    }
  }
  createGuidesLayers() {
    const mode = this.getActiveMode();
    const guides = mode.getGuides(this.getModeProps(this.props));
    if (!guides || !guides.features.length) {
      return [];
    }
    const subLayerProps = {
      linestrings: {
        billboard: this.props.billboard,
        autoHighlight: false
      },
      "polygons-fill": {
        autoHighlight: false
      },
      "polygons-stroke": {
        billboard: this.props.billboard
      }
    };
    if (this.props.editHandleType === "icon") {
      subLayerProps["points-icon"] = {
        type: import_layers6.IconLayer,
        iconAtlas: this.props.editHandleIconAtlas,
        iconMapping: this.props.editHandleIconMapping,
        sizeUnits: this.props.editHandleIconSizeUnits,
        sizeScale: this.props.editHandleIconSizeScale,
        getIcon: guideAccessor(this.props.getEditHandleIcon),
        getSize: guideAccessor(this.props.getEditHandleIconSize),
        getColor: guideAccessor(this.props.getEditHandleIconColor),
        getAngle: guideAccessor(this.props.getEditHandleIconAngle),
        billboard: this.props.billboard
      };
    } else {
      subLayerProps["points-circle"] = {
        type: import_layers6.ScatterplotLayer,
        radiusScale: this.props.editHandlePointRadiusScale,
        stroked: this.props.editHandlePointOutline,
        getLineWidth: this.props.editHandlePointStrokeWidth,
        radiusUnits: this.props.editHandlePointRadiusUnits,
        radiusMinPixels: this.props.editHandlePointRadiusMinPixels,
        radiusMaxPixels: this.props.editHandlePointRadiusMaxPixels,
        getRadius: guideAccessor(this.props.getEditHandlePointRadius),
        getFillColor: guideAccessor(this.props.getEditHandlePointColor),
        getLineColor: guideAccessor(this.props.getEditHandlePointOutlineColor),
        billboard: this.props.billboard
      };
    }
    const layer = new import_layers6.GeoJsonLayer(this.getSubLayerProps({
      id: "guides",
      data: guides,
      fp64: this.props.fp64,
      _subLayerProps: subLayerProps,
      lineWidthScale: this.props.lineWidthScale,
      lineWidthMinPixels: this.props.lineWidthMinPixels,
      lineWidthMaxPixels: this.props.lineWidthMaxPixels,
      lineWidthUnits: this.props.lineWidthUnits,
      lineJointRounded: this.props.lineJointRounded,
      lineCapRounded: this.props.lineCapRounded,
      lineMiterLimit: this.props.lineMiterLimit,
      getLineColor: guideAccessor(this.props.getTentativeLineColor),
      getLineWidth: guideAccessor(this.props.getTentativeLineWidth),
      getFillColor: guideAccessor(this.props.getTentativeFillColor),
      pointType: this.props.editHandleType === "icon" ? "icon" : "circle",
      iconAtlas: this.props.editHandleIconAtlas
    }));
    return [layer];
  }
  createTooltipsLayers() {
    const mode = this.getActiveMode();
    const tooltips = mode.getTooltips(this.getModeProps(this.props));
    const layer = new import_layers6.TextLayer({
      getSize: DEFAULT_TOOLTIP_FONT_SIZE,
      ...this.getSubLayerProps({
        id: "tooltips",
        data: tooltips
      })
    });
    return [layer];
  }
  onLayerClick(event) {
    this.getActiveMode().handleClick(event, this.getModeProps(this.props));
  }
  onLayerKeyUp(event) {
    this.getActiveMode().handleKeyUp(event, this.getModeProps(this.props));
  }
  onStartDragging(event) {
    this.getActiveMode().handleStartDragging(event, this.getModeProps(this.props));
  }
  onDragging(event) {
    this.getActiveMode().handleDragging(event, this.getModeProps(this.props));
  }
  onStopDragging(event) {
    this.getActiveMode().handleStopDragging(event, this.getModeProps(this.props));
  }
  onPointerMove(event) {
    this.setState({ lastPointerMoveEvent: event });
    this.getActiveMode().handlePointerMove(event, this.getModeProps(this.props));
  }
  getCursor({ isDragging }) {
    if (this.state === null || this.state === void 0) {
      return null;
    }
    let { cursor } = this.state;
    if (!cursor) {
      cursor = isDragging ? "grabbing" : "grab";
    }
    return cursor;
  }
  getActiveMode() {
    return this.state.mode;
  }
};
__publicField(EditableGeoJsonLayer, "layerName", "EditableGeoJsonLayer");
__publicField(EditableGeoJsonLayer, "defaultProps", defaultProps2);

// dist/editable-layers/editable-h3-cluster-layer.js
var import_geo_layers = require("@deck.gl/geo-layers");
var DEFAULT_EDIT_MODE2 = ViewMode;
var DEFAULT_H3_RESOLUTION = 9;
var EMPTY_FEATURE_COLLECTION = {
  type: "FeatureCollection",
  features: []
};
var defaultProps3 = {
  mode: DEFAULT_EDIT_MODE2,
  ...EditableGeoJsonLayer.defaultProps,
  // h3 layer
  data: [],
  selectedIndexes: [],
  filled: false,
  stroked: true,
  lineWidthScale: PROJECTED_PIXEL_SIZE_MULTIPLIER2,
  lineWidthMinPixels: 1,
  lineWidthMaxPixels: Number.MAX_SAFE_INTEGER,
  lineWidthUnits: "pixels",
  getHexagons: (d) => d.hexIds,
  getEditedCluster: (updatedHexagons, existingCluster) => {
    if (existingCluster) {
      return {
        ...existingCluster,
        hexIds: updatedHexagons
      };
    }
    return {
      hexIds: updatedHexagons
    };
  },
  resolution: DEFAULT_H3_RESOLUTION
};
var EditableH3ClusterLayer = class extends EditableLayer {
  state = void 0;
  initializeState() {
    super.initializeState();
    this.setState({
      tentativeHexagonIDs: []
    });
  }
  // convert array of (lng, lat) coords to cluster of hexes
  getDerivedHexagonIDs(coords) {
    throw new Error("not implemented");
  }
  // convert pair of (lng, lat) coords into single hex
  getDerivedHexagonID(coords) {
    throw new Error("not implemented");
  }
  renderLayers() {
    const layers = [
      new EditableGeoJsonLayer(this.getSubLayerProps({
        id: "editable-geojson",
        mode: this.props.mode,
        data: EMPTY_FEATURE_COLLECTION,
        selectedFeatureIndexes: [],
        onEdit: (editAction) => {
          const { editType, editContext } = editAction;
          switch (editType) {
            case "updateTentativeFeature":
              if (editContext.feature.geometry.type === "Polygon") {
                const coords = editContext.feature.geometry.coordinates;
                const hexIDs = this.getDerivedHexagonIDs(coords);
                this.setState({ tentativeHexagonIDs: hexIDs });
              } else if (editContext.feature.geometry.type === "Point") {
                const coords = editContext.feature.geometry.coordinates;
                const hexID = this.getDerivedHexagonID(coords);
                this.setState({ tentativeHexagonIDs: [hexID] });
              }
              break;
            case "addFeature":
              const updatedData = [...this.props.data];
              const { modeConfig } = this.props;
              if (!modeConfig || !modeConfig.booleanOperation) {
                updatedData.push(this.props.getEditedCluster(this.state.tentativeHexagonIDs, null));
              } else if (this.props.selectedIndexes.length !== 1) {
                console.warn("booleanOperation only supported for single cluster selection");
              } else {
                let finalHexagonIDs;
                const committedHexagonIDs = new Set(this.getSelectedHexIDs());
                const tentativeHexagonIDs = new Set(this.state.tentativeHexagonIDs);
                switch (modeConfig.booleanOperation) {
                  case "union":
                  default:
                    finalHexagonIDs = [
                      .../* @__PURE__ */ new Set([...committedHexagonIDs, ...tentativeHexagonIDs])
                    ];
                    break;
                  case "intersection":
                    finalHexagonIDs = [...committedHexagonIDs].filter((hexID) => tentativeHexagonIDs.has(hexID));
                    break;
                  case "difference":
                    finalHexagonIDs = [...committedHexagonIDs].filter((hexID) => !tentativeHexagonIDs.has(hexID));
                    break;
                }
                const selectedIndex = this.props.selectedIndexes[0];
                const existingCluster = this.props.data[selectedIndex];
                updatedData[selectedIndex] = this.props.getEditedCluster(finalHexagonIDs, existingCluster);
              }
              this.setState({
                tentativeHexagonIDs: []
              });
              this.props.onEdit({ updatedData });
              break;
            default:
              break;
          }
        }
      })),
      new import_geo_layers.H3ClusterLayer(this.getSubLayerProps({
        id: "hexagons",
        data: this.props.data,
        getHexagons: this.props.getHexagons
      })),
      new import_geo_layers.H3ClusterLayer(this.getSubLayerProps({
        id: "tentative-hexagons",
        data: [
          {
            hexIds: this.state.tentativeHexagonIDs
          }
        ],
        getHexagons: (d) => d.hexIds
      }))
    ];
    return layers;
  }
  // because data is an array of hexagon data, we take the cumulative of all selected indexes,
  // using props.getHexagons to support multiple data types
  getSelectedHexIDs() {
    let cumulativeHexIDs = [];
    this.props.selectedIndexes.forEach((index) => {
      const selectedCluster = this.props.data[index];
      const hexIDs = this.props.getHexagons(selectedCluster);
      cumulativeHexIDs = cumulativeHexIDs.concat(hexIDs);
    });
    return cumulativeHexIDs;
  }
  getCursor({ isDragging }) {
    let { cursor } = this.state || {};
    if (!cursor) {
      cursor = isDragging ? "grabbing" : "grab";
    }
    return cursor;
  }
};
__publicField(EditableH3ClusterLayer, "layerName", "EditableH3ClusterLayer");
__publicField(EditableH3ClusterLayer, "defaultProps", defaultProps3);

// dist/editable-layers/selection-layer.js
var import_core4 = require("@deck.gl/core");
var import_layers7 = require("@deck.gl/layers");
var import_helpers16 = require("@turf/helpers");
var import_buffer3 = __toESM(require("@turf/buffer"), 1);
var import_difference4 = __toESM(require("@turf/difference"), 1);
var SELECTION_TYPE2 = {
  NONE: null,
  RECTANGLE: "rectangle",
  POLYGON: "polygon"
};
var MODE_MAP = {
  [SELECTION_TYPE2.RECTANGLE]: DrawRectangleMode,
  [SELECTION_TYPE2.POLYGON]: DrawPolygonMode
};
var MODE_CONFIG_MAP = {
  [SELECTION_TYPE2.RECTANGLE]: { dragToDraw: true }
};
var defaultProps4 = {
  selectionType: SELECTION_TYPE2.RECTANGLE,
  layerIds: [],
  onSelect: () => {
  }
};
var EMPTY_DATA = {
  type: "FeatureCollection",
  features: []
};
var EXPANSION_KM2 = 50;
var LAYER_ID_GEOJSON = "selection-geojson";
var LAYER_ID_BLOCKER = "selection-blocker";
var PASS_THROUGH_PROPS = [
  "lineWidthScale",
  "lineWidthMinPixels",
  "lineWidthMaxPixels",
  "lineWidthUnits",
  "lineJointRounded",
  "lineCapRounded",
  "lineMiterLimit",
  "pointRadiusScale",
  "pointRadiusMinPixels",
  "pointRadiusMaxPixels",
  "lineDashJustified",
  "getLineColor",
  "getFillColor",
  "getRadius",
  "getLineWidth",
  "getLineDashArray",
  "getTentativeLineDashArray",
  "getTentativeLineColor",
  "getTentativeFillColor",
  "getTentativeLineWidth"
];
var SelectionLayer = class extends import_core4.CompositeLayer {
  state = void 0;
  _selectRectangleObjects(coordinates) {
    const { layerIds, onSelect } = this.props;
    const [x1, y1] = this.context.viewport.project(coordinates[0][0]);
    const [x2, y2] = this.context.viewport.project(coordinates[0][2]);
    const pickingInfos = this.context.deck.pickObjects({
      x: Math.min(x1, x2),
      y: Math.min(y1, y2),
      width: Math.abs(x2 - x1),
      height: Math.abs(y2 - y1),
      layerIds
    });
    onSelect({ pickingInfos });
  }
  _selectPolygonObjects(coordinates) {
    const { layerIds, onSelect } = this.props;
    const mousePoints = coordinates[0].map((c) => this.context.viewport.project(c));
    const allX = mousePoints.map((mousePoint) => mousePoint[0]);
    const allY = mousePoints.map((mousePoint) => mousePoint[1]);
    const x = Math.min(...allX);
    const y = Math.min(...allY);
    const maxX = Math.max(...allX);
    const maxY = Math.max(...allY);
    const landPointsPoly = (0, import_helpers16.polygon)(coordinates);
    const bigBuffer = (0, import_buffer3.default)(landPointsPoly, EXPANSION_KM2);
    let bigPolygon;
    try {
      bigPolygon = (0, import_difference4.default)(bigBuffer, landPointsPoly);
    } catch (e) {
      console.log("turfDifference() error", e);
      return;
    }
    this.setState({
      pendingPolygonSelection: {
        bigPolygon
      }
    });
    const blockerId = `${this.props.id}-${LAYER_ID_BLOCKER}`;
    setTimeout(() => {
      const pickingInfos = this.context.deck.pickObjects({
        x,
        y,
        width: maxX - x,
        height: maxY - y,
        layerIds: [blockerId, ...layerIds]
      });
      onSelect({
        pickingInfos: pickingInfos.filter((item) => item.layer.id !== this.props.id)
      });
    }, 250);
  }
  renderLayers() {
    const { pendingPolygonSelection } = this.state;
    const mode = MODE_MAP[this.props.selectionType] || ViewMode;
    const modeConfig = MODE_CONFIG_MAP[this.props.selectionType];
    const inheritedProps = {};
    PASS_THROUGH_PROPS.forEach((p) => {
      if (this.props[p] !== void 0)
        inheritedProps[p] = this.props[p];
    });
    const layers = [
      new EditableGeoJsonLayer(this.getSubLayerProps({
        id: LAYER_ID_GEOJSON,
        pickable: true,
        mode,
        modeConfig,
        selectedFeatureIndexes: [],
        data: EMPTY_DATA,
        onEdit: ({ updatedData, editType }) => {
          if (editType === "addFeature") {
            const { coordinates } = updatedData.features[0].geometry;
            if (this.props.selectionType === SELECTION_TYPE2.RECTANGLE) {
              this._selectRectangleObjects(coordinates);
            } else if (this.props.selectionType === SELECTION_TYPE2.POLYGON) {
              this._selectPolygonObjects(coordinates);
            }
          }
        },
        ...inheritedProps
      }))
    ];
    if (pendingPolygonSelection) {
      const { bigPolygon } = pendingPolygonSelection;
      layers.push(new import_layers7.PolygonLayer(this.getSubLayerProps({
        id: LAYER_ID_BLOCKER,
        pickable: true,
        stroked: false,
        opacity: 1,
        data: [bigPolygon],
        getLineColor: (obj) => [0, 0, 0, 1],
        getFillColor: (obj) => [0, 0, 0, 1],
        getPolygon: (o) => o.geometry.coordinates
      })));
    }
    return layers;
  }
  shouldUpdateState({ changeFlags: { stateChanged, propsOrDataChanged } }) {
    return stateChanged || propsOrDataChanged;
  }
};
__publicField(SelectionLayer, "layerName", "SelectionLayer");
__publicField(SelectionLayer, "defaultProps", defaultProps4);

// dist/editable-layers/elevated-edit-handle-layer.js
var import_core5 = require("@deck.gl/core");
var import_layers8 = require("@deck.gl/layers");
var defaultProps5 = {};
var ElevatedEditHandleLayer = class extends import_core5.CompositeLayer {
  renderLayers() {
    const handles = new import_layers8.ScatterplotLayer(Object.assign({}, this.props, {
      id: `${this.props.id}-ScatterplotLayer`,
      data: this.props.data
    }));
    const lines = new import_layers8.LineLayer(Object.assign({}, this.props, {
      id: `${this.props.id}-LineLayer`,
      data: this.props.data,
      pickable: false,
      getSourcePosition: ({ position }) => [position[0], position[1], 0],
      getTargetPosition: ({ position }) => [position[0], position[1], position[2] || 0],
      getColor: [150, 150, 150, 200],
      getStrokeWidth: 3
    }));
    return [handles, lines];
  }
};
__publicField(ElevatedEditHandleLayer, "layerName", "ElevatedEditHandleLayer");
__publicField(ElevatedEditHandleLayer, "defaultProps", defaultProps5);

// dist/edit-modes/resize-circle-mode.js
var import_nearest_point_on_line2 = __toESM(require("@turf/nearest-point-on-line"), 1);
var import_helpers17 = require("@turf/helpers");
var import_circle3 = __toESM(require("@turf/circle"), 1);
var import_distance14 = __toESM(require("@turf/distance"), 1);
var import_center2 = __toESM(require("@turf/center"), 1);
var ResizeCircleMode = class extends GeoJsonEditMode {
  _selectedEditHandle;
  _isResizing = false;
  // eslint-disable-next-line complexity
  getGuides(props) {
    const handles = [];
    const selectedFeatureIndexes = props.selectedIndexes;
    const { lastPointerMoveEvent } = props;
    const picks = lastPointerMoveEvent && lastPointerMoveEvent.picks;
    const mapCoords2 = lastPointerMoveEvent && lastPointerMoveEvent.mapCoords;
    if (picks && picks.length && mapCoords2 && selectedFeatureIndexes.length === 1 && !this._isResizing) {
      const featureAsPick = picks.find((pick) => !pick.isGuide);
      if (featureAsPick && featureAsPick.object.properties.shape && featureAsPick.object.properties.shape.includes("Circle") && props.selectedIndexes.includes(featureAsPick.index)) {
        let intermediatePoint = null;
        let positionIndexPrefix = [];
        const referencePoint = (0, import_helpers17.point)(mapCoords2);
        recursivelyTraverseNestedArrays2(featureAsPick.object.geometry.coordinates, [], (lineString3, prefix) => {
          const lineStringFeature = (0, import_helpers17.lineString)(lineString3);
          const candidateIntermediatePoint = this.getNearestPoint(
            // @ts-expect-error turf types too wide
            lineStringFeature,
            referencePoint,
            props.modeConfig && props.modeConfig.viewport
          );
          if (!intermediatePoint || candidateIntermediatePoint.properties.dist < intermediatePoint.properties.dist) {
            intermediatePoint = candidateIntermediatePoint;
            positionIndexPrefix = prefix;
          }
        });
        if (intermediatePoint) {
          const { geometry: { coordinates: position }, properties: { index } } = intermediatePoint;
          handles.push({
            type: "Feature",
            properties: {
              guideType: "editHandle",
              editHandleType: "intermediate",
              featureIndex: featureAsPick.index,
              positionIndexes: [...positionIndexPrefix, index + 1]
            },
            geometry: {
              type: "Point",
              coordinates: position
            }
          });
        }
      }
    }
    return {
      type: "FeatureCollection",
      features: handles
    };
  }
  // turf.js does not support elevation for nearestPointOnLine
  getNearestPoint(line, inPoint, viewport) {
    const { coordinates } = line.geometry;
    if (coordinates.some((coord) => coord.length > 2)) {
      if (viewport) {
        return nearestPointOnProjectedLine2(line, inPoint, viewport);
      }
      console.log("Editing 3D point but modeConfig.viewport not provided. Falling back to 2D logic.");
    }
    return (0, import_nearest_point_on_line2.default)(line, inPoint);
  }
  handleDragging(event, props) {
    const editHandle = getPickedEditHandle(event.pointerDownPicks);
    if (editHandle) {
      event.cancelPan();
      const editHandleProperties = editHandle.properties;
      const feature = this.getSelectedFeature(props);
      const center = (0, import_center2.default)(feature).geometry.coordinates;
      const numberOfSteps = Object.entries(feature.geometry.coordinates[0]).length - 1;
      const radius = Math.max((0, import_distance14.default)(center, event.mapCoords), 1e-3);
      const { steps = numberOfSteps } = {};
      const options = { steps };
      const updatedFeature = (0, import_circle3.default)(center, radius, options);
      const geometry = updatedFeature.geometry;
      const updatedData = new ImmutableFeatureCollection(props.data).replaceGeometry(editHandleProperties.featureIndex, geometry).getObject();
      props.onEdit({
        updatedData,
        editType: "unionGeometry",
        editContext: {
          featureIndexes: [editHandleProperties.featureIndex]
        }
      });
    }
  }
  handlePointerMove(event, props) {
    if (!this._isResizing) {
      const selectedEditHandle = getPickedEditHandle(event.picks);
      this._selectedEditHandle = selectedEditHandle && selectedEditHandle.properties.editHandleType === "intermediate" ? selectedEditHandle : null;
    }
    const cursor = this.getCursor(event);
    props.onUpdateCursor(cursor);
  }
  handleStartDragging(event, props) {
    if (this._selectedEditHandle) {
      event.cancelPan();
      this._isResizing = true;
    }
  }
  handleStopDragging(event, props) {
    if (this._isResizing) {
      this._selectedEditHandle = null;
      this._isResizing = false;
    }
  }
  getCursor(event) {
    const picks = event && event.picks || [];
    const handlesPicked = getPickedEditHandles(picks);
    if (handlesPicked.length) {
      return "cell";
    }
    return null;
  }
};

// dist/edit-modes/extend-line-string-mode.js
var ExtendLineStringMode = class extends GeoJsonEditMode {
  getSingleSelectedLineString(props) {
    const selectedGeometry = this.getSelectedGeometry(props);
    if (selectedGeometry && selectedGeometry.type === "LineString") {
      return selectedGeometry;
    }
    return null;
  }
  handleClick(event, props) {
    const { selectedIndexes } = props;
    const selectedLineString = this.getSingleSelectedLineString(props);
    if (!selectedLineString) {
      console.warn(`ExtendLineStringMode only supported for single LineString selection`);
      return;
    }
    let positionIndexes = [selectedLineString.coordinates.length];
    const modeConfig = props.modeConfig;
    if (modeConfig && modeConfig.drawAtFront) {
      positionIndexes = [0];
    }
    const featureIndex = selectedIndexes[0];
    const updatedData = new ImmutableFeatureCollection(props.data).addPosition(featureIndex, positionIndexes, event.mapCoords).getObject();
    props.onEdit({
      updatedData,
      editType: "addPosition",
      editContext: {
        featureIndexes: [featureIndex],
        positionIndexes,
        position: event.mapCoords
      }
    });
  }
  getGuides(props) {
    const guides = {
      type: "FeatureCollection",
      features: []
    };
    const selectedLineString = this.getSingleSelectedLineString(props);
    if (!selectedLineString) {
      return guides;
    }
    const mapCoords2 = props.lastPointerMoveEvent && props.lastPointerMoveEvent.mapCoords;
    if (!mapCoords2) {
      return guides;
    }
    let startPosition = null;
    const { modeConfig } = props;
    if (modeConfig && modeConfig.drawAtFront) {
      startPosition = selectedLineString.coordinates[0];
    } else {
      startPosition = selectedLineString.coordinates[selectedLineString.coordinates.length - 1];
    }
    guides.features.push({
      type: "Feature",
      properties: {
        guideType: "tentative"
      },
      geometry: {
        type: "LineString",
        coordinates: [startPosition, mapCoords2]
      }
    });
    return guides;
  }
  handlePointerMove(event, props) {
    props.onUpdateCursor("cell");
  }
};

// dist/edit-modes/measure-distance-mode.js
var import_distance15 = __toESM(require("@turf/distance"), 1);
var import_midpoint = __toESM(require("@turf/midpoint"), 1);
var MeasureDistanceMode = class extends GeoJsonEditMode {
  _isMeasuringSessionFinished = false;
  _currentTooltips = [];
  _currentDistance = 0;
  _calculateDistanceForTooltip = ({ positionA, positionB, modeConfig }) => {
    const { turfOptions, measurementCallback } = modeConfig || {};
    const distance7 = (0, import_distance15.default)(positionA, positionB, turfOptions);
    if (measurementCallback) {
      measurementCallback(distance7);
    }
    return distance7;
  };
  _formatTooltip(distance7, modeConfig) {
    const { formatTooltip, turfOptions } = modeConfig || {};
    const units = turfOptions && turfOptions.units || "kilometers";
    let text;
    if (formatTooltip) {
      text = formatTooltip(distance7);
    } else {
      text = `${parseFloat(distance7).toFixed(2)} ${units}`;
    }
    return text;
  }
  handleClick(event, props) {
    const { modeConfig, data, onEdit } = props;
    const { centerTooltipsOnLine = false } = modeConfig || {};
    if (this._isMeasuringSessionFinished) {
      this._isMeasuringSessionFinished = false;
      this.resetClickSequence();
      this._currentTooltips = [];
      this._currentDistance = 0;
    }
    const { picks } = event;
    const clickedEditHandle = getPickedEditHandle(picks);
    let positionAdded = false;
    if (!clickedEditHandle) {
      this.addClickSequence(event);
      positionAdded = true;
    }
    const clickSequence = this.getClickSequence();
    if (clickSequence.length > 1 && clickedEditHandle && Array.isArray(clickedEditHandle.properties.positionIndexes) && clickedEditHandle.properties.positionIndexes[0] === clickSequence.length - 1) {
      this._isMeasuringSessionFinished = true;
    } else if (positionAdded) {
      if (clickSequence.length > 1) {
        this._currentDistance += this._calculateDistanceForTooltip({
          positionA: clickSequence[clickSequence.length - 2],
          positionB: clickSequence[clickSequence.length - 1],
          modeConfig
        });
        const tooltipPosition = centerTooltipsOnLine ? (0, import_midpoint.default)(clickSequence[clickSequence.length - 2], clickSequence[clickSequence.length - 1]).geometry.coordinates : event.mapCoords;
        this._currentTooltips.push({
          position: tooltipPosition,
          text: this._formatTooltip(this._currentDistance, modeConfig)
        });
      }
      onEdit({
        // data is the same
        updatedData: data,
        editType: "addTentativePosition",
        editContext: {
          position: event.mapCoords
        }
      });
    }
  }
  handleKeyUp(event, props) {
    if (this._isMeasuringSessionFinished)
      return;
    event.stopPropagation();
    const { key } = event;
    const clickSequenceLength = this.getClickSequence().length;
    switch (key) {
      case "Escape":
        this._isMeasuringSessionFinished = true;
        if (clickSequenceLength === 1) {
          this.resetClickSequence();
          this._currentTooltips = [];
        }
        props.onUpdateCursor("cell");
        break;
      case "Enter":
        this.handleClick(props.lastPointerMoveEvent, props);
        this._isMeasuringSessionFinished = true;
        break;
      default:
        break;
    }
  }
  getGuides(props) {
    const { lastPointerMoveEvent } = props;
    const clickSequence = this.getClickSequence();
    const lastCoords = lastPointerMoveEvent && !this._isMeasuringSessionFinished ? [lastPointerMoveEvent.mapCoords] : [];
    const guides = {
      type: "FeatureCollection",
      features: []
    };
    if (clickSequence.length > 0) {
      guides.features.push({
        type: "Feature",
        properties: {
          guideType: "tentative"
        },
        geometry: {
          type: "LineString",
          coordinates: [...clickSequence, ...lastCoords]
        }
      });
    }
    const editHandles = clickSequence.map((clickedCoord, index) => ({
      type: "Feature",
      properties: {
        guideType: "editHandle",
        editHandleType: "existing",
        featureIndex: -1,
        positionIndexes: [index]
      },
      geometry: {
        type: "Point",
        coordinates: clickedCoord
      }
    }));
    guides.features.push(...editHandles);
    return guides;
  }
  handlePointerMove(event, props) {
    props.onUpdateCursor("cell");
  }
  getTooltips(props) {
    const { lastPointerMoveEvent, modeConfig } = props;
    const { centerTooltipsOnLine = false } = modeConfig || {};
    const positions = this.getClickSequence();
    if (positions.length > 0 && lastPointerMoveEvent && !this._isMeasuringSessionFinished) {
      const distance7 = this._calculateDistanceForTooltip({
        positionA: positions[positions.length - 1],
        positionB: lastPointerMoveEvent.mapCoords,
        modeConfig: props.modeConfig
      });
      const tooltipPosition = centerTooltipsOnLine ? (0, import_midpoint.default)(positions[positions.length - 1], lastPointerMoveEvent.mapCoords).geometry.coordinates : lastPointerMoveEvent.mapCoords;
      return [
        ...this._currentTooltips,
        {
          position: tooltipPosition,
          text: this._formatTooltip(this._currentDistance + distance7, modeConfig)
        }
      ];
    }
    return this._currentTooltips;
  }
};

// dist/edit-modes/measure-area-mode.js
var import_area3 = __toESM(require("@turf/area"), 1);
var import_centroid3 = __toESM(require("@turf/centroid"), 1);
var DEFAULT_TOOLTIPS2 = [];
var MeasureAreaMode = class extends DrawPolygonMode {
  handleClick(event, props) {
    const propsWithoutEdit = {
      ...props,
      onEdit: () => {
      }
    };
    super.handleClick(event, propsWithoutEdit);
  }
  handleKeyUp(event, props) {
    const propsWithoutEdit = {
      ...props,
      onEdit: () => {
      }
    };
    super.handleKeyUp(event, propsWithoutEdit);
  }
  getTooltips(props) {
    const tentativeGuide = this.getTentativeGuide(props);
    if (tentativeGuide && tentativeGuide.geometry.type === "Polygon") {
      const { modeConfig } = props;
      const { formatTooltip, measurementCallback } = modeConfig || {};
      const units = "sq. m";
      const centroid = (0, import_centroid3.default)(tentativeGuide);
      const area3 = (0, import_area3.default)(tentativeGuide);
      let text;
      if (formatTooltip) {
        text = formatTooltip(area3);
      } else {
        text = `${parseFloat(area3).toFixed(2)} ${units}`;
      }
      if (measurementCallback) {
        measurementCallback(area3);
      }
      return [
        {
          position: centroid.geometry.coordinates,
          text
        }
      ];
    }
    return DEFAULT_TOOLTIPS2;
  }
};

// dist/edit-modes/measure-angle-mode.js
var import_bearing10 = __toESM(require("@turf/bearing"), 1);
var import_center3 = __toESM(require("@turf/center"), 1);
var DEFAULT_TOOLTIPS3 = [];
var MeasureAngleMode = class extends GeoJsonEditMode {
  _getTooltips = memoize(({ modeConfig, vertex, point1, point2: point22 }) => {
    let tooltips = DEFAULT_TOOLTIPS3;
    if (vertex && point1 && point22) {
      const { formatTooltip, measurementCallback } = modeConfig || {};
      const units = "deg";
      const angle1 = (0, import_bearing10.default)(vertex, point1);
      const angle2 = (0, import_bearing10.default)(vertex, point22);
      let angle = Math.abs(angle1 - angle2);
      if (angle > 180) {
        angle = 360 - angle;
      }
      let text;
      if (formatTooltip) {
        text = formatTooltip(angle);
      } else {
        text = `${parseFloat(angle).toFixed(2)} ${units}`;
      }
      if (measurementCallback) {
        measurementCallback(angle);
      }
      const position = (0, import_center3.default)({
        type: "FeatureCollection",
        features: [point1, point22].map((p) => ({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: p
          },
          properties: {}
        }))
      }).geometry.coordinates;
      tooltips = [{ position, text }];
    }
    return tooltips;
  });
  handleClick(event, props) {
    if (this.getClickSequence().length >= 3) {
      this.resetClickSequence();
    }
    this.addClickSequence(event);
  }
  // Called when the pointer moved, regardless of whether the pointer is down, up, and whether something was picked
  handlePointerMove(event, props) {
    props.onUpdateCursor("cell");
  }
  getPoints(props) {
    const clickSequence = this.getClickSequence();
    const points = [...clickSequence];
    if (clickSequence.length < 3 && props.lastPointerMoveEvent) {
      points.push(props.lastPointerMoveEvent.mapCoords);
    }
    return points;
  }
  // Return features that can be used as a guide for editing the data
  getGuides(props) {
    const guides = { type: "FeatureCollection", features: [] };
    const { features } = guides;
    const points = this.getPoints(props);
    if (points.length > 2) {
      features.push({
        type: "Feature",
        properties: { guideType: "tentative" },
        geometry: {
          type: "LineString",
          coordinates: [points[1], points[0], points[2]]
        }
      });
    } else if (points.length > 1) {
      features.push({
        type: "Feature",
        properties: { guideType: "tentative" },
        geometry: {
          type: "LineString",
          coordinates: [points[1], points[0]]
        }
      });
    }
    return guides;
  }
  getTooltips(props) {
    const points = this.getPoints(props);
    return this._getTooltips({
      modeConfig: props.modeConfig,
      vertex: points[0],
      point1: points[1],
      point2: points[2]
    });
  }
};
//# sourceMappingURL=index.cjs.map
